import moved from "./ar.moved";
import builder from "./ar.builder";
import builtins from "./ar.builtins";
import generic from "./ar.generic";
import pages from "./ar.pages";
import decisionControls from "./ar.decisions";

export default {
  ...moved,
  ...builtins,
  ...generic,
  ...pages,
  builder,
  decisionControls,
  app: {
    title: "إدارة المنصة",
    subtitle: "إعداد الخدمات ومسارات العمل والوكلاء والتكاملات للمنصة الوطنية للمنافسة – من دون برمجة.",
    openBackoffice: "فتح إدارة الحالات",
    openPortal: "فتح بوابة الخدمات",
    version: "المنصة {{version}}",
    help: "المساعدة",
    docs: "دليل المسؤول",
  },
  login: {
    title: "تسجيل الدخول إلى إدارة المنصة",
    subtitle: "الوصول الإداري مقصور على مسؤولي المنصة عبر الشبكة الفيدرالية للوزارة.",
    noAccess: "لا تملك هذه الهوية صلاحيات إدارة المنصة. يرجى تسجيل الدخول بحساب مسؤول.",
    sessionNote: "تتطلب كل جلسة كلمة المرور ورمز المصادقة. وتنتهي الجلسة بعد 30 دقيقة دون نشاط و10 ساعات كحد أقصى.",
    capabilities: {
      services: "تصميم الخدمات ونماذج التقديم",
      workflows: "ترقيم نسخ مسارات العمل مع تثبيت الحالات الجارية",
      agents: "إعداد الوكلاء والتعليمات والضوابط",
      integrations: "ربط الأنظمة الحكومية ومزودي الهوية",
    },
  },
  nav: {
    data: "البيانات",
    reports: "التقارير",
    screens: "الشاشات",
    tools: "أدوات الوكلاء",
    environments: "البيئات",
    overview: "نظرة عامة",
    build: "البناء",
    services: "الخدمات",
    forms: "النماذج",
    workflows: "مسارات العمل",
    rules: "القواعد",
    automations: "الأتمتة",
    aiWorkspace: "المساعد الذكي",
    workspaces: "مساحات العمل",
    pages: "استوديو الصفحات",
    assistants: "المساعدون",
    knowledge: "المعرفة",
    solutions: "الحلول",
    ai: "الذكاء الاصطناعي",
    agents: "الوكلاء",
    models: "النماذج والمزودون",
    governance: "حوكمة الذكاء الاصطناعي",
    connect: "الربط",
    integrations: "التكاملات",
    connectors: "الموصلات",
    webhooks: "الويب هوك",
    apiClients: "عملاء API",
    identity: "الهوية والوصول",
    identityProviders: "مزودو الهوية",
    users: "المستخدمون",
    roles: "الأدوار والصلاحيات",
    content: "القوالب والمحتوى",
    operate: "التشغيل",
    settings: "الإعدادات",
    flags: "خصائص التفعيل",
    secrets: "الأسرار",
    releases: "الإصدارات",
    packages: "الحزم",
    audit: "التدقيق والأمن",
    feedback: "البلاغات الواردة",
  },
  shell: {
    breadcrumbs: "مسار التنقل",
    searchPlaceholder: "البحث في إدارة المنصة…",
    commandPalette: "لوحة الأوامر",
    commandHint: "كتابة أمر أو بحث…",
    noResults: "لا توجد نتائج مطابقة.",
    groups: { navigate: "الانتقال إلى", actions: "إجراءات", recent: "الأخيرة", definitions: "التعريفات" },
    shortcuts: "اختصارات لوحة المفاتيح",
    shortcutList: {
      workspaces: "الانتقال إلى مساحات العمل",
      solutions: "الانتقال إلى الحلول",
      palette: "فتح لوحة الأوامر",
      search: "التركيز على البحث",
      overview: "الانتقال إلى النظرة العامة",
      services: "الانتقال إلى الخدمات",
      workflows: "الانتقال إلى مسارات العمل",
      releases: "الانتقال إلى الإصدارات",
      help: "عرض هذه القائمة",
      save: "حفظ المسودة الحالية",
    },
    unsavedTitle: "تغييرات غير محفوظة",
    unsavedBody: "لديك تغييرات لم تحفظ بعد. هل تريد مغادرة الصفحة وتجاهلها؟",
    stay: "البقاء",
    discard: "تجاهل التغييرات",
    environment: "البيئة",
    savedViews: "طرق العرض المحفوظة",
    saveView: "حفظ طريقة العرض الحالية",
    viewName: "اسم طريقة العرض",
    deleteView: "حذف طريقة العرض",
    noSavedViews: "لا توجد طرق عرض محفوظة بعد.",
    goToBackoffice: "فتح في إدارة الحالات",
    signOut: "تسجيل الخروج",
    help: "المساعدة والوثائق",
    helpHint: "ما تقوم به هذه الشاشة، وكيف تطلق التغييرات، وأين تقرأ المزيد.",
  },
  overview: {
    title: "نظرة عامة على المنصة",
    subtitle: "صحة مكونات المنصة، والوكلاء الذين يعملون كخدمات، والأنظمة المتصلة، وكل ما ينتظر قرار إصدار.",
    health: "صحة المنصة",
    healthHint: "كل مكون يعتمد عليه محرك مسارات العمل. تعطل وكيل أو موصل لا يوقف المحرك أبدا: تستمر الحالات في الحركة، ويتأخر فقط الجزء المدعوم بالذكاء الاصطناعي.",
    components: { api: "واجهة البرمجة", database: "PostgreSQL", storage: "تخزين الملفات", jobs: "المهام الخلفية", realtime: "التحديث الفوري", llm: "بوابة النماذج" },
    status: { Healthy: "سليم", Degraded: "متدن", Down: "متوقف", Unknown: "غير معروف" },
    queues: "طوابير المهام",
    queuesHint: "يعمل الوكلاء على طابور `agents` بعد إتمام كل معاملة؛ وتعمل مسوحات المدد القانونية والإشعارات على `default`.",
    queue: { name: "الطابور", enqueued: "بالانتظار", processing: "قيد التنفيذ", failed: "فشل", succeeded24h: "أنجز (24 ساعة)" },
    agents: "الوكلاء كخدمات",
    agentsHint: "يعمل كل وكيل بمعزل عن غيره بميزانيته وضوابطه وإعادة محاولاته. نسبة النجاح وزمن الاستجابة خلال آخر 24 ساعة.",
    agent: { name: "الوكيل", runs: "التشغيلات", success: "النجاح", p95: "p95", lastFailure: "آخر فشل", never: "لا يوجد" },
    connectors: "الأنظمة المتصلة",
    connectorsHint: "التكاملات الصادرة مع حالة قاطع الدائرة وآخر فحص.",
    connector: { name: "النظام", health: "الصحة", breaker: "القاطع", latency: "زمن الاستجابة", lastCall: "آخر استدعاء" },
    breaker: { Closed: "مغلق", Open: "مفتوح", HalfOpen: "نصف مفتوح" },
    providers: "مزودو النماذج",
    providersHint: "أين يعمل الاستدلال اليوم ومكان إقامة البيانات لدى كل مزود.",
    approvals: "بانتظار الإصدار",
    approvalsHint: "مجموعات التغييرات التي تحتاج إلى مراجعة ثانية قبل أن تدخل حيز التنفيذ.",
    noApprovals: "لا شيء ينتظر الموافقة.",
    recentChanges: "آخر تغييرات المنصة",
    recentChangesHint: "مجموعات التغييرات المنشورة والتفعيلات وتعديلات الإعدادات من سلسلة التدقيق.",
    drift: "انحراف التقييم",
    driftHint: "تنبيهات ترفع عندما تفقد مجموعة تقييم أكثر من عشر نقاط دقة.",
    noDrift: "لا توجد تنبيهات انحراف.",
    spend: "إنفاق النماذج",
    spendHint: "تكلفة استدعاءات النماذج خلال آخر 30 يوما حسب الفئة.",
    runningCases: "الحالات الجارية حسب نسخة مسار العمل",
    runningCasesHint: "تحتفظ الحالات بنسخة مسار العمل التي بدأت عليها. وتسحب النسخ القديمة عند إغلاق آخر حالة عليها.",
    openConsole: "فتح",
    viewAll: "عرض الكل",
    refreshed: "حدث {{when}}",
    workspaces: "مساحات العمل",
    workspacesHint: "اعتماد المساعد الذكي لكل إدارة: المحادثات والموظفون النشطون هذا الأسبوع، والإنفاق مقابل الميزانية الشهرية، وما ينتظر المراجعة.",
    workspace: {
      summary: "{{assistants}} مساعدين · {{members}} أعضاء",
      pending: "للمراجعة: {{count}}",
      threads7d: "محادثات · 7 أيام",
      activeUsers: "نشطون · 7 أيام",
      runs: "تشغيلات الوكلاء · الشهر",
      threadsTotal: "{{count}} في المجموع",
      membersTotal: "من إجمالي الأعضاء ({{count}})",
      artifacts: "المخرجات: {{count}}",
      spend: "الإنفاق هذا الشهر",
    },
  },
  releases: {
    title: "الإصدارات",
    subtitle: "كل تغيير على خدمة أو نموذج أو إجراء أو قاعدة أو وكيل أو موصل أو دور أو خاصية أو إعداد يصبح نافذا عبر مجموعة تغييرات: يراجعها المستشار، ويعتمدها مسؤول ثان، ويمكن جدولتها والتراجع عنها.",
    newRelease: "إصدار جديد",
    newReleaseHint: "يجمع الإصدار نسخ التعريفات التي يجب أن تصبح نافذة معا. تضاف العناصر من أدوات البناء عبر «إضافة إلى الإصدار».",
    created: "تم إنشاء الإصدار.",
    empty: "لا توجد إصدارات مطابقة.",
    emptyHint: "يبدأ العمل بإنشاء إصدار ثم إضافة العناصر إليه من استوديو الإجراءات ومنشئ النماذج وبقية الأدوات.",
    searchPlaceholder: "البحث بالعنوان أو مقدم الطلب أو مفتاح التعريف…",
    allStatuses: "كل الحالات",
    tabs: { open: "مفتوحة", history: "السجل", all: "الكل" },
    columns: { title: "الإصدار", items: "العناصر", risk: "المخاطر", requestedBy: "مقدم الطلب", effective: "النفاذ" },
    approvedBy: "اعتمده {{name}}",
    immediate: "عند الاعتماد",
    isRollback: "إصدار تراجع",
    pendingHint: "بحاجة إلى مسؤول ثان.",
    nextScheduled: "التالي: {{title}} في {{when}}",
    noScheduled: "لا شيء مجدول.",
    lastPublished: "الأخير: {{title}} بواسطة {{by}}",
    noPublished: "لم ينشر شيء بعد.",
    rollbackHint: "أعيدت النسخ السابقة.",
    backToQueue: "عودة إلى الإصدارات",
    detailSubtitle: "طلبه {{by}} · {{when}}",
    items: "العناصر",
    itemsHint: "نسخ التعريفات في هذا الإصدار، تطبق بالترتيب. اختيار عنصر يعرض الفروقات.",
    noItems: "لا توجد عناصر بعد.",
    addFromBuilders: "تضاف العناصر من أدوات البناء، بفتح مسودة في استوديو الإجراءات أو منشئ النماذج أو مكتبة القواعد أو منشئ الوكلاء واختيار «إضافة إلى الإصدار».",
    removeItem: "إزالة",
    runningCases: "الحالات الجارية: {{count}}",
    advisor: "مراجعة المستشار",
    advisorHint: "مراجعة حتمية لكل عنصر (الفروقات، الحالات الجارية، المخاطر حسب نوع التغيير) ترفق عند تقديم الإصدار. عناصر الإجراءات تحصل أيضا على مراجعة مستشار تغيير الإجراءات بالنموذج اللغوي وتربط أدناه عند وصولها.",
    noReview: "ترفق مراجعة المستشار عند تقديم الإصدار.",
    rerunReview: "إعادة المراجعة",
    llmAdvisories: "مستشار تغيير الإجراءات",
    evaluation: {
      title: "اختبارات إطلاق الوكلاء",
      hint: "يجب أن تنجح كل نسخة وكيل في هذا الإصدار في حالات اختبارها وفي حزمة الاختبار العدائي قبل اعتمادها.",
      score: "{{passed}}/{{total}} حالة · {{red}}/{{redTotal}} اختبار عدائي · {{by}} · {{when}}",
      never: "لم يقيم بعد",
      blockedTitle: "الاعتماد موقوف",
      blockedBody: "نسخ الوكلاء التالية لم تنجح في اختبارات الإطلاق: {{agents}}. يفتح الوكيل ويشغل التقييم، ثم يعتمد الإصدار بعد نجاحه.",
    },
    aiUpdate: {
      title: "تحديث في الذكاء الاصطناعي (الشرطان 1.5 و3.7)",
      body: "يغير هذا الإصدار نموذجا أو تعليمات وكيل: {{items}}. يجوز تسليمه إلى بيئة الاختبار الآن، ولا يصل إلى بيئة الإنتاج إلا بعد اجتياز كل الملفات المرجعية وسيناريوهات الجزء السادس وبموافقة الإدارة الكتابية.",
      bodyRequired: "يغير هذا الإصدار نموذجا أو تعليمات وكيل: {{items}}. ولا يعتمد في هذه المنصة إلا بموافقة الإدارة الكتابية وبتشغيل الملفات المرجعية وسيناريوهات الجزء السادس الذي اجتازه.",
      departmentApproval: "موافقة الإدارة الكتابية",
      departmentApprovalHint: "مرجع خطاب الإدارة أو رسالتها التي توافق على التغيير وتاريخه.",
      referenceRun: "تشغيل الملفات المرجعية",
      referenceRunHint: "تشغيل الملفات المرجعية وسيناريوهات الجزء السادس على هذا التغيير ونتيجته.",
    },
    gate: {
      title: "إصدار إلى بيئة الإنتاج (الشرط 1.5)",
      body: "لا يطبق أي تغيير على هذه البيئة دون موافقة الإدارة الخطية، التي لا تمنح إلا بعد اجتياز التغيير كل الملفات المرجعية وكل سيناريوهات الجزء السادس. ويجوز تطبيق إصلاح أمني عاجل بموافقة الإدارة وحدها، على أن يجتاز المجموعة كاملة خلال خمسة أيام عمل.",
      urgent: "إصلاح أمني عاجل",
      urgentHint: "يعتمد بموافقة الإدارة وحدها، ويستحق تشغيل كل الملفات المرجعية وسيناريوهات الجزء السادس خلال خمسة أيام عمل ويسجل على الإصدار.",
      urgentRunsTitle: "إصلاح أمني عاجل: يستحق تشغيل المجموعة كاملة",
      runDue: "{{title}}: يستحق تشغيل كل الملفات المرجعية وسيناريوهات الجزء السادس قبل {{date}}.",
      runOverdue: "{{title}}: كان تشغيل كل الملفات المرجعية وسيناريوهات الجزء السادس مستحقا قبل {{date}} ولم يسجل.",
      recordRun: "تسجيل تشغيل الملفات المرجعية",
      recordRunHint: "مرجع تشغيل كل الملفات المرجعية وسيناريوهات الجزء السادس على هذا الإصلاح الأمني العاجل ونتيجته.",
      runRecorded: "سجل تشغيل الملفات المرجعية على الإصدار.",
      installationTitle: "الإصدار الذي تعمل به هذه البيئة (الشرط 1.5)",
      installationApproved: "الإصدار {{version}}، بموافقة الإدارة ({{approval}}) على تشغيل الملفات المرجعية {{run}}.",
      installationUrgent: "الإصدار {{version}}، إصلاح أمني عاجل بموافقة الإدارة ({{approval}})، ويستحق تشغيل المجموعة كاملة قبل {{due}}.",
      installationNotApproved: "لا توجد موافقة مسجلة للإدارة على الإصدار {{version}}، ولا تعمل بيئة الإنتاج به.",
    },
    fourEyesTitle: "بانتظار مسؤول ثان",
    fourEyesBody: "أنت من طلب هذا الإصدار، لذا يجب أن يعتمده شخص آخر يملك صلاحية الاعتماد (قاعدة الأربع أعين).",
    scheduledTitle: "مجدول",
    scheduledBody: "هذا الإصدار معتمد وسينشر تلقائيا في {{when}}. يمكنك نشره الآن أو إعادة فتحه أو رفضه قبل ذلك.",
    approveHint: "الاعتماد ينشر الإصدار فورا. يمكن إضافة ملاحظة اختيارية لسلسلة التدقيق.",
    approveScheduledHint: "الاعتماد يجدول الإصدار في {{when}}؛ ينشره المجدول تلقائيا.",
    rejectHint: "يمكن لمقدم الطلب تعديل الإصدار وإعادة تقديمه.",
    rollbackConfirm: "إصدار التراجع يعيد النسخة المنشورة سابقا لكل عنصر بترتيب معكوس. الحالات الجارية لا تتأثر.",
    cancelHint: "يسحب الإصدار وتبقى التعريفات مسودات.",
    fields: { title: "العنوان", effectiveFrom: "نافذ من", effectiveFromHint: "اتركه فارغا للنشر عند الاعتماد. تاريخ مستقبلي يجدول الإصدار.", reason: "السبب / الملاحظة" },
    actions: { submit: "تقديم للاعتماد", approve: "اعتماد", reject: "رفض", publishNow: "نشر الآن", reopen: "إعادة فتح كمسودة", cancel: "إلغاء الإصدار", rollback: "تراجع", addToRelease: "إضافة إلى الإصدار", stageAndOpen: "أضيف إلى الإصدار «{{title}}»" },
    toasts: { submitted: "قدم للاعتماد.", approved: "تم الاعتماد.", scheduled: "تم الاعتماد؛ وينشر في تاريخ سريانه.", rejected: "تم الرفض.", published: "تم النشر.", reopened: "أعيد فتحه كمسودة.", cancelled: "ألغي الإصدار.", rolledBack: "تم التراجع.", reviewed: "حدثت مراجعة المستشار.", itemRemoved: "أزيل العنصر." },
    failed: { publish: "لم ينشر الإصدار: تعذر نشره فوسم بأنه فاشل", approve: "اعتمد الإصدار ولم ينشر: تعذر نشره فوسم بأنه فاشل", rollback: "لم يتم التراجع: يبقى الإصدار كما نشر" },
    timeline: { created: "أنشئ الإصدار", submitted: "قدم للاعتماد", advisor: "مخاطر المستشار: {{risk}}", approved: "اعتمد (أربع أعين)", selfApproved: "اعتمده مقدم الطلب", rejected: "رفض", scheduled: "مجدول", published: "نشر", failed: "فشل النشر", rolledBack: "تم التراجع", cancelled: "ألغي" },
    status: { Draft: "مسودة", PendingApproval: "بانتظار الاعتماد", Approved: "معتمد", Scheduled: "مجدول", Published: "منشور", Rejected: "مرفوض", RolledBack: "متراجع عنه", Failed: "فشل", Cancelled: "ملغى" },
    risk: { Minimal: "مخاطر ضئيلة", Low: "مخاطر منخفضة", Medium: "مخاطر متوسطة", High: "مخاطر عالية" },
    kinds: { Publish: "نشر", Retire: "إحالة للتقاعد", Setting: "إعداد", Flag: "خاصية", Role: "دور" },
    types: { service: "خدمة", form: "نموذج", rule: "قاعدة", automation: "أتمتة", agent: "وكيل", connector: "موصل", workflow: "إجراء", setting: "إعداد", flag: "خاصية", role: "دور", template: "قالب", identityProvider: "مزود هوية", llmProvider: "مزود نماذج", fee: "جدول رسوم", analysisPolicy: "منهجية الاحتساب" },
    diff: { patch: "التغييرات", before: "قبل", after: "بعد", firstVersion: "أول نسخة منشورة – لا شيء للمقارنة.", noChanges: "لا فرق هيكلي عن النسخة المنشورة.", nothing: "—" },
    help: {
      what: "الإصدارات هي مجموعات تغييرات: تضم نسخ التعريفات (إجراءات، نماذج، قواعد، وكلاء، موصلات، خدمات) إضافة إلى تغييرات الأدوار والخصائص والإعدادات التي تصبح نافذة معا.",
      fourEyes: "يقدم مقدم الطلب؛ يرفق المستشار مراجعة المخاطر؛ يعتمد مسؤول مختلف. الإصدارات ذات تاريخ نفاذ مستقبلي ينشرها المجدول.",
      rollback: "يمكن التراجع عن إصدار منشور ما لم يمس إصدار لاحق التعريفات ذاتها. التراجع نفسه إصدار، فيبقى السجل كاملا.",
    },
  },
  packages: {
    title: "الحزم",
    subtitle: "حزم الحلول تنقل الإعدادات بين عمليات النشر: صدر الخدمات والإجراءات والنماذج والقواعد والوكلاء والموصلات والقوالب والأدوار والخصائص والإعدادات في ملف واحد موثق بالتحقق؛ واستوردها على منصة فارغة كإصدار مسودة.",
    exportPackage: "تصدير حزمة",
    importPackage: "استيراد حزمة",
    gallery: "المعرض",
    galleryHint: "ابدأ نشرا جديدا من قالب أو استخرج هذه الإدارة كحزمة.",
    galleryKind: { builtin: "قالب مدمج", package: "حزمة قالب" },
    exportTemplate: "تصدير كحزمة",
    exporting: "جار التصدير…",
    stored: "الحزم",
    storedHint: "الحزم المصدرة والمرفوعة والمستوردة على هذه المنصة.",
    templates: "القوالب",
    templatesHint: "مداخل المعرض الجاهزة للتثبيت.",
    lastExport: "آخر تصدير",
    lastImport: "آخر استيراد",
    nothingYet: "لا شيء بعد.",
    byAt: "{{name}} · {{when}}",
    empty: "لا توجد حزم بعد.",
    emptyHint: "صدر إدارة المنافسة من المعرض، أو استورد ملف حزمة للبدء.",
    columns: { package: "الحزمة", items: "العناصر", size: "الحجم", provenance: "المصدر", changeSet: "الإصدار" },
    status: { Draft: "مرفوعة", Exported: "مصدرة", Imported: "مستوردة", Failed: "فشلت" },
    exportedBy: "صدرها {{name}}",
    importedBy: "استوردها {{name}}",
    uploaded: "مرفوعة، لم تستورد بعد",
    openRelease: "فتح الإصدار",
    noRelease: "—",
    itemsByType: "{{count}} {{type}}",
    wizard: {
      title: "تصدير حزمة حل",
      hint: "يتم هنا اختيار التعريفات المطلوبة. تضاف الاعتماديات (النموذج الذي تستخدمه الخدمة، الأدوار التي يشير إليها الإجراء…) تلقائيا.",
      steps: { details: "التفاصيل", items: "التعريفات", review: "المراجعة" },
      key: "مفتاح الحزمة",
      keyHint: "معرف بأحرف صغيرة يستخدم في أسماء الملفات، مثل moet-competition-department.",
      publisher: "الناشر",
      resolveDeps: "تضمين الاعتماديات",
      resolveDepsHint: "إضافة التعريفات التي تشير إليها العناصر المختارة كي تثبت الحزمة بسلاسة على منصة فارغة.",
      isTemplate: "إظهارها في المعرض كقالب",
      selectAllType: "كل {{type}}",
      selected: "المختارة: {{count}}",
      searchItems: "تصفية التعريفات…",
      noItemsOfType: "لا شيء منشور.",
      reviewHint: "هذا ما ستحتويه الحزمة. العناصر المضافة كاعتماديات تظهر ما استلزمها.",
      requiredBy: "استلزمها {{by}}",
      warnings: "تحذيرات",
      exportNow: "تصدير",
      exported: "تم تصدير الحزمة.",
      nothingSelected: "يلزم اختيار تعريف واحد على الأقل.",
    },
    upload: {
      title: "استيراد حزمة حل",
      hint: "يمكن رفع ملف .ncp-package.json أو لصق محتواه. تتحقق الحزمة (المجاميع، الاعتماديات) وتعرض قبل إنشاء أي شيء – وحتى حينها لا ينشأ إلا مسودات داخل إصدار.",
      drop: "إسقاط ملف الحزمة هنا أو النقر للاختيار",
      paste: "أو لصق JSON الحزمة",
      pasteHint: "يلزم لصق المستند كاملا بما فيه البيان.",
      uploadAction: "تحقق",
      uploaded: "تم رفع الحزمة والتحقق منها.",
      invalidJson: "النص الملصق ليس JSON صالحا.",
    },
    detail: {
      back: "عودة إلى الحزم",
      manifest: "البيان",
      manifestHint: "كل تعريف في الحزمة مع مجموع التحقق. عند تخطيط الحزمة على هذه المنصة يظهر كل صف ما سيفعله الاستيراد.",
      plan: "خطة الاستيراد",
      planHint: "التحقق من الملف مقابل هذه المنصة: المجاميع والتنسيق والاعتماديات والإجراء لكل عنصر. لا يكتب شيء حتى تستورد.",
      planning: "جار التخطيط…",
      checksumOk: "تم التحقق من جميع المجاميع",
      checksumFailed: "فشل التحقق – عدل الملف بعد التصدير",
      format: "التنسيق {{format}} · مصدر من المنصة {{platform}}",
      missingDeps: "غير موجود على هذه المنصة",
      missingDepsHint: "تشير إليه عناصر الحزمة لكنه غير مضمن ولا موجود هنا.",
      import: "استيراد إلى إصدار مسودة",
      importHint: "تصبح عناصر الإنشاء/التحديث المختارة مسودات (نسخ جديدة) مجموعة في إصدار مسودة واحد. تنشأ الأدوار والخصائص معطلة/بلا صلاحيات؛ والإصدار يمنحها.",
      releaseTitle: "عنوان الإصدار",
      submit: "تقديم الإصدار للاعتماد فورا",
      importNow: "استيراد العناصر ({{count}})",
      nothingToImport: "كل ما اختير موجود مسبقا على هذه المنصة.",
      imported: "تم استيراد الحزمة إلى إصدار مسودة.",
      partial: "تم الاستيراد مع إخفاقات عددها {{count}}.",
      result: "نتيجة الاستيراد",
      outcome: { staged: "أدرج في الإصدار", unchanged: "بلا تغيير", skipped: "تم التخطي", failed: "فشل", create: "غير مختار", update: "غير مختار" },
      openChangeSet: "فتح الإصدار",
      download: "تنزيل",
      delete: "حذف الحزمة",
      deleteConfirm: "حذف ملف الحزمة؟ تحفظ الحزم المستوردة للمصدر.",
      deleted: "تم حذف الحزمة.",
      sha: "SHA-256",
      size: "الحجم",
      created: "أنشئت",
      platform: "المنصة",
      dependencies: "اعتماديات خارجية",
      dependenciesHint: "يتوقع وجودها على المنصة الهدف.",
      action: { create: "إنشاء", update: "نسخة جديدة", unchanged: "بلا تغيير", unsupported: "غير مدعوم", invalid: "غير صالح" },
      current: "هنا: v{{version}}",
      selectImportable: "اختيار كل ما يمكن استيراده",
      provenance: "المصدر",
      inStorage: "محفوظة في تخزين الكائنات",
      inDatabase: "محفوظة في قاعدة البيانات",
      importedInto: "استوردت إلى الإصدار",
    },
    help: {
      what: "حزمة الحل هي بيان إضافة إلى JSON القياسي لكل تعريف، ولكل منها مجموع SHA-256. «إدارة المنافسة» هي الحزمة التي تحول منصة فارغة إلى هذا النشر؛ وتصدر كل دائرة اقتصادية حزمتها بالطريقة ذاتها.",
      import: "الاستيراد لا يغير المنصة العاملة مباشرة أبدا: يصبح كل عنصر نسخة مسودة مجموعة في إصدار واحد يمر بمراجعة المستشار واعتماد العينين الأربع.",
      secrets: "لا تصدر الأسرار أبدا – تحمل الموصلات والمزودات مراجع secret:// فقط، وتوفر المنصة الهدف القيم.",
    },
  },
  settings: {
    title: "الإعدادات والخصائص",
    subtitle: "إعدادات نظام مبنية على مخطط، وخصائص قابلة للتوجيه، ومخزن أسرار مشفر. الإعدادات التي تمس السلوك القانوني تتغير عبر إصدار؛ وسائرها يطبق فورا ويسجل في التدقيق.",
    tabs: { settings: "الإعدادات", flags: "خصائص المنتج", secrets: "الأسرار" },
    groups: "المجموعات",
    overridden: "المعدلة: {{count}}",
    showAdvanced: "إظهار المتقدم",
    default: "افتراضي",
    changed: "معدل",
    release: "إصدار",
    releaseHint: "تغييرات هذا الإعداد تمر عبر إصدار (اعتماد بعينين أربع).",
    restart: "إعادة تشغيل",
    restartHint: "تعاد تشغيل الواجهة قبل استخدام القيمة الجديدة.",
    resetToDefault: "استعادة الافتراضي",
    resetDone: "أعيدت القيمة الافتراضية.",
    saved: "تم حفظ الإعداد.",
    staged: "أضيف التغيير إلى الإصدار المسودة.",
    testEnvironmentLine: "بيئة الاختبار – ضوابط القرار مخففة، وليس هذا سلوك منصة الإنتاج:",
    testEnvironmentCodes: {
      Registers: "تنبه السجلات بدلا من منع التوقيع",
      Heads: "يتولى المدير ومن فوقه كل صلاحية ويوقعون كل قرار",
      Penalty: "خطوات الجزاء مفتوحة قبل تأكيد الأساس",
      Letters: "لا يوقف الخطاب الذي يستشهد بأحكام غير متحقق منها لهذا السبب وحده",
    },
    openRelease: "فتح الإصدار",
    invalidJson: "JSON غير صالح.",
    defaultIs: "الافتراضي: {{value}}",
    updatedAt: "عدل {{when}}",
    jsonEditor: "قيمة JSON",
    noSettings: "لا إعدادات في هذه المجموعة.",
    help: {
      what: "توصف الإعدادات بمخطط (المجموعة، النوع، الخيارات، الافتراضي) كي تعرضها الواجهة وتتحقق منها وتقارنها. تحفظ القيم في system_settings حيث يقرأها الكود الحالي.",
      release: "الإعدادات الموسومة «إصدار» لا تتغير مباشرة: حفظها يدرج عنصرا في مجموعة تغييرات يعتمدها مسؤول ثان. وسائر الإعدادات تطبق فورا وتكتب في سلسلة التدقيق.",
      secrets: "تشفر الأسرار بـ ASP.NET Data Protection ويشار إليها من الموصلات والمزودات والويب هوك بصيغة secret://key. تعرض الواجهة الأسماء والتلميحات ومواضع الاستخدام – وليس القيمة أبدا.",
    },
    flags: {
      title: "خصائص المنتج",
      hint: "تتحكم الخصائص في الانتقال التدريجي (portal.dynamicIntake.<service>) وفي كل قدرة جديدة في الواجهة. التبديل فوري؛ والتوجيه يتيح تفعيل الخاصية لأدوار أو أشخاص قبل الجميع.",
      newFlag: "خاصية جديدة",
      editFlag: "تعديل الخاصية",
      known: "يستخدمها الكود",
      knownHint: "يشير إليها كود المنصة؛ يمكن تعطيلها لكن لا حذفها.",
      custom: "مخصصة",
      on: "مفعلة",
      off: "معطلة",
      targeted: "موجهة",
      percentage: "نشر {{value}}%",
      roles: "الأدوار: {{roles}}",
      users: "{{count}} شخص", users_zero: "لا أشخاص", users_one: "شخص واحد", users_two: "شخصان", users_few: "{{count}} أشخاص", users_many: "{{count}} شخصا", users_other: "{{count}} شخص",
      expires: "تنتهي {{when}}",
      expired: "منتهية",
      categories: { portal: "البوابة", backoffice: "المكتب الخلفي", console: "الواجهة", agents: "الوكلاء", automations: "الأتمتة", integrations: "التكاملات", identity: "الهوية", experiments: "تجارب", general: "عام" },
      fields: {
        key: "المفتاح", keyHint: "مفتاح بأحرف صغيرة منقط، مثل portal.dynamicIntake.lq.", category: "الفئة", enabled: "مفعلة للجميع", enabledHint: "عند التعطيل لا يرى الخاصية إلا الأدوار والأشخاص الموجهون.",
        roles: "مفعلة للأدوار", rolesHint: "أعضاء هذه الأدوار يحصلون على الخاصية دائما.", users: "مفعلة للأشخاص", usersHint: "معرفات المستخدمين، واحد في كل سطر أو مفصولة بفواصل.",
        percentage: "نسبة النشر", percentageHint: "ثابتة لكل شخص: يبقى المستخدم في الجهة ذاتها مع زيادة النسبة.", expiresAt: "تنتهي في", expiresHint: "تذكير اختياري لتنظيف الخاصية.",
      },
      toasts: { enabled: "تم تفعيل الخاصية.", disabled: "تم تعطيل الخاصية.", saved: "تم حفظ الخاصية.", created: "تم إنشاء الخاصية.", deleted: "تم حذف الخاصية." },
      deleteConfirm: "حذف هذه الخاصية؟ سيقرأها أي كود ما زال يسأل عنها كمعطلة.",
      empty: "لا خصائص بعد.",
    },
    secrets: {
      title: "الأسرار",
      hint: "القيم للكتابة فقط: بعد الحفظ يظهر تلميح (الأحرف الأخيرة) ومواضع الإشارة إلى السر. ويتم التدوير بإدخال قيمة جديدة.",
      newSecret: "سر جديد",
      rotate: "تدوير",
      rotateTitle: "تدوير السر",
      test: "اختبار",
      testOk: "يمكن فك تشفير السر ({{length}} حرفا).",
      testFailed: "تعذر قراءة السر.",
      reference: "المرجع",
      referenceHint: "الصقه في حقل موصل أو مزود أو ويب هوك.",
      usedBy: "يستخدمه",
      unused: "غير مشار إليه",
      rotated: "دور {{when}} بواسطة {{name}}",
      neverRotated: "لم يدور",
      expires: "ينتهي {{when}}",
      expired: "منته",
      fromEnv: "متغير بيئة",
      envMissing: "غير مضبوط",
      envPresent: "موجود",
      fields: {
        key: "المفتاح", keyHint: "مفتاح بأحرف صغيرة منقط، مثل eia.apiKey.", value: "القيمة", valueHint: "تحفظ مشفرة. اتركها فارغة عند تغيير الوصف أو الانتهاء فقط.", newValue: "القيمة الجديدة",
        description: "الوصف", expiresAt: "ينتهي في", env: "متغير بيئة (تهيئة أولية)", envHint: "اقرأ القيمة من هذا المتغير وقت التشغيل بدل النص المشفر – للأسرار التي يوفرها النشر.",
      },
      dangling: "أسرار مفقودة",
      danglingHint: "تشير الإعدادات إلى هذه المفاتيح لكن لا سر معرف – سيفشل الموصل أو المزود المشير إليها.",
      createMissing: "إنشاء",
      deleteConfirm: "حذف هذا السر؟ سيفشل كل ما يشير إليه في المصادقة.",
      forceDelete: "احذف على أي حال",
      inUse: "يشار إلى هذا السر من {{by}}.",
      toasts: { saved: "تم حفظ السر.", rotated: "تم تدوير السر.", deleted: "تم حذف السر." },
      empty: "لا أسرار بعد.",
      emptyHint: "أنشئ سرا وأشر إليه بصيغة secret://key من الموصلات والمزودات.",
    },
  },
  identity: {
    title: "الهوية والصلاحيات",
    subtitle: "من يستطيع فعل ماذا: دليل الموظفين والمتعاملين، الأدوار ومصفوفة صلاحياتها، مزودو الهوية، وعملاء الأنظمة التي تستدعي واجهة المنصة.",
    tabs: { users: "المستخدمون", roles: "الأدوار والصلاحيات", apiClients: "عملاء الواجهة", providers: "مزودو الهوية" },
    areas: { platform: "إدارة المنصة", cases: "الحالات", ai: "الذكاء الاصطناعي", databank: "بنك البيانات", api: "واجهة الأنظمة" },
    help: {
      roles: "الأدوار بيانات: تعكس الأدوار المدمجة تسلسل الوزارة (الموظف ← الوزير) ويمكن منحها صلاحيات إضافية؛ وتنشأ الأدوار الجديدة (مثل أمين لجنة) هنا وتصبح قابلة للاستخدام فورا في مسارات العمل والأتمتة.",
      users: "يدخل الموظفون بهوية الوزارة والمتعاملون بالهوية الرقمية. تسري الأدوار الممنوحة هنا مع الطلب التالي دون إعادة تسجيل دخول.",
      apiClients: "عملاء الواجهة للأنظمة لا للأشخاص: يستبدلون معرف العميل وسره برمز قصير الأجل نطاقاته صلاحيات api.*، مع إمكانية حصره بخدمات وبقائمة عناوين IP مسموحة.",
      providers: "يتيح مزودو الهوية للموظفين الدخول بدليل الوزارة. تربط مجموعات الدليل بالأدوار ومساحات العمل عند كل تسجيل دخول، ويعرض سجل «آخر عمليات الدخول» ما طابقته كل عملية وسبب أي رفض.",
    },
    providers: {
      hint: "يدخل الموظفون بدليل الوزارة (Microsoft Entra ID أو أي مزود OpenID Connect). تتحقق كل عملية دخول من مفاتيح التوقيع المنشورة لدى المزود، ثم تحدد مجموعات الحساب أدواره في المنصة وعضويته في مساحات العمل، فتتبع حالات الانضمام والتنقل والمغادرة الدليل تلقائيا.",
      newProvider: "مزود جديد",
      editProvider: "تعديل المزود",
      dialogHint: "يلزم تسجيل المنصة تطبيقا لدى المزود (عنوان إعادة التوجيه: صفحة ‎/login في كل واجهة للموظفين)، ثم إدخال المصدر ومعرف العميل وسره، وربط مجموعات الدليل.",
      empty: "لا يوجد مزود هوية بعد",
      emptyHint: "إضافة Microsoft Entra ID أو أي مصدر OpenID Connect تتيح للموظفين الدخول بحساب الوزارة.",
      simulated: "محاكاة",
      simulatedHint: "تخدمه أدوات المحاكاة: تعرض صفحات الدخول حسابات الدليل المحاكى بدل صفحة المزود نفسه. يعمل في الوضع التجريبي فقط.",
      kinds: { EntraId: "Microsoft Entra ID", Oidc: "OpenID Connect", IdentityServer: "Identity Server" },
      linkedUsers_zero: "لا مستخدمين مرتبطين",
      linkedUsers_one: "مستخدم مرتبط واحد",
      linkedUsers_two: "مستخدمان مرتبطان",
      linkedUsers_few: "{{count}} مستخدمين مرتبطين",
      linkedUsers_many: "{{count}} مستخدما مرتبطا",
      linkedUsers_other: "{{count}} مستخدم مرتبط",
      lastSignIn: "آخر دخول {{when}}",
      noSignIns: "لا عمليات دخول بعد",
      tested: "اختبر {{when}}",
      neverTested: "لم يختبر بعد",
      test: "اختبار الاتصال",
      testOk: "الاتصال سليم",
      testFailed: "فشل الاتصال",
      signIns: "آخر عمليات الدخول",
      signInsHint: "أحدث عمليات الدخول عبر {{name}}: المجموعات التي طابقت وما منحته. وتوضح حالات الرفض السبب.",
      noRecentSignIns: "لم يدخل أحد عبر هذا المزود بعد.",
      outcome: { signedIn: "دخل", refused: "مرفوض", failed: "فشل" },
      newAccount: "حساب جديد",
      linkedByEmail: "ربط بالبريد الإلكتروني",
      matched: "المجموعات المطابقة",
      granted: "الممنوح",
      mappingsSummary: "{{roles}} ربط أدوار · {{workspaces}} ربط مساحات عمل",
      policy: { jit: "ينشئ الحسابات عند أول دخول", noJit: "حسابات معدة مسبقا فقط", sync: "الدليل هو المرجع", link: "يربط بالبريد الإلكتروني" },
      domains: "النطاقات: {{domains}}",
      deleteTitle: "حذف المزود",
      deleteConfirm: "حذف «{{name}}»؟ لن يتمكن الموظفون من الدخول به. تبقى حساباتهم وروابطهم، فإعادة إنشاء المزود بالمفتاح نفسه تعيد الدخول.",
      sections: { general: "عام", connection: "الاتصال", claims: "المطالبات", roles: "ربط الأدوار", workspaces: "ربط مساحات العمل", policy: "سياسة الدخول" },
      fields: {
        kind: "نوع المزود",
        issuer: "المصدر",
        issuerHint: "كما ينشره المزود تماما؛ تقرأ المنصة منه ‎/.well-known/openid-configuration. في Entra ID: https://login.microsoftonline.com/<tenant id>/v2.0",
        clientId: "معرف العميل (التطبيق)",
        clientSecret: "سر العميل",
        clientSecretHint: "سر من الإعدادات › الأسرار. بلا سر للعميل العام (PKCE فقط).",
        noSecret: "بلا سر (عميل عام)",
        scopes: "النطاقات",
        scopesHint: "مفصولة بمسافات؛ ويجب أن تتضمن openid.",
        pkce: "PKCE",
        pkceHint: "مفتاح إثبات لتبادل الرمز. أبقه مفعلا.",
        advanced: "تجاوز نقاط النهاية",
        advancedHint: "لا حاجة إليه إلا إذا كانت وثيقة الاكتشاف لدى المزود مفقودة أو خاطئة.",
        authorizationEndpoint: "نقطة التفويض",
        tokenEndpoint: "نقطة الرموز",
        userInfoEndpoint: "نقطة بيانات المستخدم",
        jwksUri: "عنوان المفاتيح (JWKS)",
        endSessionEndpoint: "نقطة تسجيل الخروج",
        extraParams: "معاملات تفويض إضافية",
        extraParamsHint: "مثل prompt = select_account أو domain_hint = moet.gov.ae.",
        subjectClaim: "مطالبة المعرف",
        subjectClaimHint: "تميز الشخص عبر عمليات الدخول. في Entra ID: ‏oid (معرف الكائن).",
        emailClaim: "مطالبة البريد الإلكتروني",
        nameClaim: "مطالبة الاسم",
        nameArClaim: "مطالبة الاسم العربي",
        groupsClaim: "مطالبة المجموعات",
        groupsClaimHint: "حيث تصل قيم المجموعات أو أدوار التطبيق: groups أو roles…",
        claim: "المطالبة",
        value: "القيمة",
        label: "التسمية",
        role: "الدور",
        workspace: "مساحة العمل",
        owner: "مالك",
        claimPlaceholder: "مطالبة المجموعات",
        valuePlaceholder: "معرف كائن المجموعة أو قيمة الدور",
        labelPlaceholder: "مثل SG-LegalAffairs-Counsel",
        choose: "اختر…",
        addRoleMapping: "إضافة ربط دور",
        addWorkspaceMapping: "إضافة ربط مساحة عمل",
        rolesHint: "كل من تحمل مطالبته القيمة يحمل الدور. تسجل الأدوار المدمجة في سجل الموظف، والأدوار المخصصة إسنادات موسومة بأنها من الدليل.",
        workspacesHint: "كل من تحمل مطالبته القيمة يصبح عضوا (أو مالكا) في مساحة العمل، إضافة إلى الأدوار التي تقبلها المساحة.",
        defaultRoles: "أدوار للجميع",
        defaultRolesHint: "تمنح لكل مستخدم لهذا المزود أيا كانت مجموعاته.",
        jit: "إنشاء الحسابات عند أول دخول",
        jitHint: "عند الإيقاف: لا يدخل إلا من لديه حساب في المنصة مسبقا.",
        linkByEmail: "ربط الحسابات القائمة بالبريد الإلكتروني",
        linkByEmailHint: "يلحق أول دخول بحساب الموظف ذي البريد الإلكتروني نفسه.",
        sync: "الدليل هو المرجع",
        syncHint: "عند كل دخول تسحب الأدوار والعضويات الممنوحة عبر هذا المزود متى توقفت المجموعات عن حملها. ولا يمس ما تمنحه إدارة المنصة.",
        allowedDomains: "نطاقات البريد المسموحة",
        allowedDomainsHint: "مفصولة بفواصل، مثل moet.gov.ae. فارغة: كل من يزكيه المصدر.",
        appEconic: "يسجل الدخول إلى ECONIC",
        appNcp: "يسجل الدخول إلى NCP (المكتب الخلفي ولوحة الإدارة والبوابة)",
        appsHint: "يسجل ECONIC وNCP كل على حدة في دليل الوزارة. إن لم يحدد أي منهما فالمزود يسجل الدخول إلى كليهما.",
        mfaWithin: "المصادقة متعددة العوامل من الدليل خلال (بالدقائق)",
        mfaWithinHint: "تحل المصادقة متعددة العوامل في الدليل محل مصادقة المنصة: يجب أن يظهر كل دخول مصادقة أتمت خلال هذه المدة، وإلا طلبت مرة أخرى. فارغ: فقط حيث يشترط الخادم ذلك.",
        profileSync: "الملف الشخصي من الدليل",
        profileSyncHint: "عند كل دخول: الاسم والمسمى الوظيفي والإدارة والهاتف المتحرك والمدير والصورة من Microsoft Graph. ويبقى ما تحفظه المنصة لأي حقل يتركه الدليل فارغا.",
        arabicName: "سمة الاسم بالعربية",
        arabicNameHint: "السمة الإضافية في الدليل المحلي التي تحفظ الاسم بالعربية، من extensionAttribute1 إلى extensionAttribute15. فارغة: يبقى الاسم العربي كما في المنصة.",
        enabledHint: "يظهر في صفحات دخول الموظفين.",
      },
      toasts: { created: "أنشئ المزود.", saved: "حفظ المزود.", deleted: "حذف المزود.", enabled: "فعل المزود.", disabled: "عطل المزود." },
    },
    roles: {
      hint: "علم خلية لمنح صلاحية لدور. الخلايا الذهبية ناتجة عن نمط عام (مثل platform.*) وتحرر في الدور نفسه. دور المسؤول يملك كل الصلاحيات دائما.",
      matrix: "مصفوفة الصلاحيات",
      matrixHint: "الأدوار أفقيا، والصلاحيات عموديا مجمعة حسب المجال.",
      permission: "الصلاحية",
      allAreas: "كل المجالات",
      showDisabled: "إظهار الأدوار المعطلة",
      newRole: "دور جديد",
      editRole: "تعديل الدور",
      builtIn: "مدمج",
      builtInHint: "يعكس دورا وظيفيا من تسلسل الوزارة. يمكن توسيع صلاحياته؛ أما المفتاح وحالة التفعيل فثابتان.",
      builtInEditHint: "تحتفظ الأدوار المدمجة بمفتاحها وتبقى مفعلة؛ ويمكن توسيع صلاحياتها أو تقليصها.",
      dialogHint: "سم الدور واختر صلاحياته. يمكن منحه للأشخاص والإشارة إليه في مهام المسار واستهدافه بالخصائص فورا.",
      disabled: "معطل",
      members: "{{count}} عضو", members_zero: "لا أعضاء", members_one: "عضو واحد", members_two: "عضوان", members_few: "{{count}} أعضاء", members_many: "{{count}} عضوا", members_other: "{{count}} عضو",
      permissionCount: "{{count}} صلاحية", permissionCount_zero: "لا صلاحيات", permissionCount_one: "صلاحية واحدة", permissionCount_two: "صلاحيتان", permissionCount_few: "{{count}} صلاحيات", permissionCount_many: "{{count}} صلاحية", permissionCount_other: "{{count}} صلاحية",
      all: "الكل",
      keyHint: "معرف ثابت يستخدم في المسارات والحزم، مثل committee-secretary.",
      rank: "الترتيب",
      rankHint: "ترتيب الظهور في القوائم؛ الأصغر أولا.",
      color: "اللون",
      assignable: "قابل للمنح",
      assignableHint: "يمكن منحه للمستخدمين من الدليل.",
      department: "الإدارة", departmentHint: "يظهر دور الإدارة في إجراءات تلك الإدارة وخدماتها.", allDepartments: "مشترك بين جميع الإدارات", departmentBadge: "الإدارة: {{department}}",
      enabled: "مفعل",
      enabledHint: "الأدوار المعطلة لا تمنح شيئا لكنها تحتفظ بتعييناتها.",
      permissions: "الصلاحيات",
      clear: "مسح",
      superuser: "يملك هذا الدور كل الصلاحيات (*) ولا يمكن تقليصه هنا.",
      dangerous: "صلاحية عالية التأثير",
      dangerousSelected: "الصلاحيات عالية التأثير المختارة: {{count}} – تنشر أو تعتمد أو تغير إعدادات الأمن.",
      wildcardHint: "ممنوحة عبر نمط عام – عدل الدور لتغييرها.",
      viaWildcard: "عبر نمط عام",
      deleteTitle: "حذف الدور",
      deleteConfirm: "حذف «{{name}}»؟ تزال تعييناته، وتحتفظ المسارات التي تشير إليه بالمفتاح.",
      reset: "إعادة الضبط للافتراضي",
      resetHint: "استعادة صلاحيات هذا الدور المضمن إلى الإعدادات الافتراضية للمنصة.",
      toasts: { created: "تم إنشاء الدور.", saved: "تم حفظ الدور.", deleted: "تم حذف الدور.", reset: "تمت استعادة الصلاحيات الافتراضية." },
      builtInNames: { Admin: "المسؤول", Minister: "الوزير", Undersecretary: "وكيل الوزارة", AssistantUndersecretary: "الوكيل المساعد", Director: "المدير", HeadOfComplaints: "رئيس قسم الشكاوى", EconomicResearcher: "باحث اقتصادي", LegalResearcher: "باحث قانوني", EconomicExpert: "خبير اقتصادي", LegalExpert: "خبير قانوني", JudicialOfficer: "مأمور ضبط قضائي", CommitteeMember: "عضو لجنة", Applicant: "المتعامل", Representative: "الممثل", Auditor: "المدقق" },
    },
    users: {
      account: {
        title: "حساب تسجيل الدخول",
        hint: "حساب بكلمة مرور ومصادقة. تصدر إعادة التعيين كلمة مرور لمرة واحدة تسلم شخصيا، ولا ترسل بالبريد الإلكتروني.",
        status: { active: "نشط", first_sign_in: "بانتظار أول تسجيل دخول", locked: "مقفل", deactivated: "معطل", no_credential: "دون كلمة مرور بعد", directory: "حساب الوزارة" },
        factor: "تطبيق المصادقة",
        factorOn: "معد",
        factorOff: "غير معد",
        sessions: "الجلسات النشطة: {{count}}",
        issue: "إصدار كلمة مرور",
        resetPassword: "إعادة تعيين كلمة المرور",
        resetMfa: "إعادة تعيين المصادقة",
        unlock: "إلغاء القفل",
        signOut: "إنهاء جميع الجلسات",
        tempTitle: "كلمة مرور مؤقتة (تعرض مرة واحدة)",
        tempHint: "تسلم للشخص مباشرة؛ لا ترسل بالبريد الإلكتروني ولا يمكن عرضها مرة أخرى.",
        tempExpires: "تنتهي {{when}}",
        copy: "نسخ",
        copied: "تم النسخ",
        secondAdmin: "يجب أن يعيد مسؤول آخر تعيين المصادقة.",
        selfChange: "يغير حسابك الخاص مسؤول آخر.",
        unavailable: "حسابات تسجيل الدخول غير متاحة على هذا الخادم بعد.",
        done: "تم",
      },
      search: "البحث بالاسم أو البريد أو المسمى…",
      kinds: { Staff: "الموظفون", External: "المتعاملون", System: "النظام" },
      anyRole: "أي دور",
      includeInactive: "تضمين غير النشطين",
      columns: { user: "المستخدم", title: "المسمى / المنشأة", roles: "الأدوار", lastLogin: "آخر دخول", status: "الحالة" },
      active: "نشط",
      inactive: "غير نشط",
      demo: "شخصية تجريبية",
      viaProvider: "يدخل عبر {{name}}",
      fromDirectory: "من الدليل",
      never: "لم يدخل قط",
      lastLogin: "آخر دخول {{when}}",
      empty: "لا مستخدمين مطابقين.",
      builtInRoles: "أدوار الوزارة",
      builtInRolesHint: "من سجل الموظف (مزود الهوية أو البذر). تغيرها الموارد البشرية لا هنا.",
      assignedRoles: "أدوار إدارة المنصة",
      noAssigned: "لا أدوار إضافية.",
      assign: "منح دور",
      unassign: "إزالة الدور",
      role: "الدور",
      validUntil: "صالح حتى",
      validUntilHint: "اختياري – للتكليفات المؤقتة ومدد اللجان.",
      activate: "تفعيل",
      deactivate: "إيقاف",
      activateHint: "يعيد تسجيل الدخول وإسناد المهام.",
      deactivateHint: "يمنع تسجيل الدخول فورا؛ تبقى المهام المفتوحة مسندة حتى تعاد.",
      deactivateConfirm: "إيقاف {{name}}؟ سيخرج من الجلسة ولن يستطيع الدخول حتى يفعل.",
      toasts: { assigned: "تم منح الدور.", unassigned: "تمت إزالة الدور.", activated: "تم تفعيل المستخدم.", deactivated: "تم إيقاف المستخدم." },
    },
    apiClients: {
      hint: "تستخدم عملاء الأنظمة (بوابة OutSystems، تكامل الدوائر الاقتصادية، ذكاء الأعمال) اعتماد العميل في OAuth 2.0. النطاقات هي صلاحيات api.*، ولا يمنح الرمز أكثر مما لعميله. تعطيل العميل يرفض رموزه فورا.",
      newClient: "عميل واجهة جديد",
      editClient: "تعديل عميل الواجهة",
      create: "إنشاء العميل",
      dialogHint: "تحدد النطاقات التي يحتاجها النظام، وتحصر بخدمات إن أمكن، وتثبت شبكة المستدعي. يعرض السر مرة واحدة بعد الإنشاء.",
      empty: "لا عملاء واجهة بعد.",
      emptyHint: "أنشئ عميلا للبوابة الخارجية أو نظام شريك ثم اشترك به في الويب هوك.",
      clientId: "معرف العميل",
      clientIdHint: "معرف بأحرف صغيرة يرسله النظام كـ client_id.",
      clientSecret: "سر العميل",
      secretHint: "السر {{hint}}",
      scopes: "النطاقات",
      scopesHint: "مفاتيح الصلاحيات التي يحملها الرمز.",
      needScope: "امنح نطاقا واحدا على الأقل.",
      services: "الخدمات",
      servicesHint: "فارغ = كل الخدمات. يحصر بيانات الحالات بهذه الخدمات.",
      allServices: "كل الخدمات",
      restrictedTo: "محصور بخدمات عددها {{count}}",
      ipAllowList: "قائمة IP المسموحة",
      ipAllowListHint: "عناوين IP أو نطاقات CIDR، واحد في كل سطر. فارغ = أي عنوان. يفحص عند إصدار الرمز ومع كل طلب.",
      anyIp: "أي عنوان",
      tokenLifetime: "مدة الرمز",
      tokenLifetimeHint: "من 5 إلى 1440 دقيقة.",
      minutes: "{{count}} دقيقة", minutes_zero: "لا دقائق", minutes_one: "دقيقة واحدة", minutes_two: "دقيقتان", minutes_few: "{{count}} دقائق", minutes_many: "{{count}} دقيقة", minutes_other: "{{count}} دقيقة",
      lastUsed: "آخر رمز",
      neverUsed: "أبدا",
      tokensIssued: "الرموز المصدرة",
      owner: "المالك",
      contactEmail: "بريد التواصل",
      enabled: "مفعل",
      disabled: "معطل",
      webhooks: "ويب هوك: {{count}}",
      rotatedAt: "تم تدوير السر {{when}}",
      rotate: "تدوير السر",
      rotateTitle: "تدوير سر العميل",
      rotateConfirm: "إصدار سر جديد لـ «{{name}}»؟ يتوقف السر الحالي فورا؛ وتبقى الرموز الحالية صالحة حتى انتهائها.",
      deleteTitle: "حذف عميل الواجهة",
      deleteConfirm: "حذف «{{name}}»؟ ترفض رموزه فورا وتبقى ويب هوكاته بلا مالك.",
      credentialsTitle: "اعتمادات العميل",
      credentialsHint: "سلمها لفريق التكامل عبر قناة آمنة.",
      credentialsOnce: "يعرض السر الآن فقط. خزنه في مخزن أسرار النظام الشريك؛ ودوره هنا إن تسرب.",
      stored: "خزنت السر",
      howTo: "استخدام واجهة الأنظمة",
      howToHint: "استبدل الاعتمادات برمز حامل (client_credentials) ثم استدع /api/v1 به. ترسل الخدمات الإلكترونية الطلبات إلى الأدلة الإجرائية الموسومة «خدمات إلكترونية» وتتابعها برقمها المرجعي.",
      procedures: "الإجراءات",
      playbooks: "الأدلة الإجرائية",
      eServices: "خدمات إلكترونية",
      unpublished: "لم تعد منشورة:",
      removeService: "إزالة {{key}}",
      toasts: { created: "تم إنشاء عميل الواجهة.", saved: "تم حفظ عميل الواجهة.", rotated: "تم تدوير السر.", enabled: "تم تفعيل العميل.", disabled: "تم تعطيل العميل.", deleted: "تم حذف عميل الواجهة." },
    },
  },
  webhooks: {
    title: "الويب هوك الصادرة",
    hint: "يعرض كل حدث في المنصة (تقديم حالة، تغير حالة، مهلة في خطر، اعتماد مقترح…) على الاشتراكات المطابقة ويرسل بتوقيع HMAC. تعاد المحاولة عند الإخفاق بتراجع تدريجي؛ ويظهر السجل كل محاولة.",
    subscriptions: "الاشتراكات",
    enabledCount: "المفعلة: {{count}}",
    pending: "قيد الانتظار",
    pendingHint: "في الطابور أو بانتظار إعادة المحاولة.",
    delivered24h: "تم التسليم",
    failed24h: "فشل",
    last24h: "آخر 24 ساعة",
    empty: "لا ويب هوك بعد.",
    emptyHint: "اشترك البوابة الخارجية أو نظاما شريكا في أحداث الحالات.",
    newWebhook: "ويب هوك جديد",
    editWebhook: "تعديل الويب هوك",
    dialogHint: "تحدد الأحداث والخدمات المطلوب تمريرها، ونقطة النهاية، والسر المستخدم لتوقيع كل تسليم.",
    url: "عنوان نقطة النهاية",
    urlHint: "يلزم https (يسمح بـ http للأهداف المحلية فقط).",
    signingSecret: "سر التوقيع",
    signingSecretHint: "يتحقق المستلم من X-NCP-Signature: t=<unix>,v1=HMAC-SHA256(secret, \"<t>.<body>\").",
    signed: "موقع",
    unsigned: "غير موقع",
    secretMissing: "سر التوقيع غير معرف",
    apiClient: "عميل الواجهة المالك",
    apiClientHint: "اختياري – يتيح لذلك العميل عرض اشتراكاته عبر الواجهة.",
    headers: "ترويسات إضافية",
    headersHint: "واحدة في كل سطر بصيغة الاسم: القيمة. يمكن أن تكون القيم مراجع secret://.",
    maxAttemptsLabel: "أقصى عدد محاولات",
    maxAttempts: "{{count}} محاولة", maxAttempts_zero: "لا محاولات", maxAttempts_one: "محاولة واحدة", maxAttempts_two: "محاولتان", maxAttempts_few: "{{count}} محاولات", maxAttempts_many: "{{count}} محاولة", maxAttempts_other: "{{count}} محاولة",
    events: "الأحداث",
    eventsHint: "أنواع محددة أو أنماط مثل case.*.",
    allEvents: "كل الأحداث",
    customEvent: "custom.event.type",
    services: "الخدمات",
    allServices: "كل الخدمات",
    restrictedTo: "{{count}} خدمة", restrictedTo_zero: "لا خدمات", restrictedTo_one: "خدمة واحدة", restrictedTo_two: "خدمتان", restrictedTo_few: "{{count}} خدمات", restrictedTo_many: "{{count}} خدمة", restrictedTo_other: "{{count}} خدمة",
    ownedBy: "المالك: {{name}}",
    failing: "الإخفاقات المتتالية: {{count}}",
    lastDelivered: "آخر تسليم {{when}}",
    neverDelivered: "لم يسلم قط",
    stats: "{{pending}} منتظر · {{ok}} ناجح · {{failed}} فاشل (24 س)",
    viewDeliveries: "التسليمات",
    test: "إرسال اختبار",
    deliveryLog: "سجل التسليم",
    deliveryLogHint: "آخر 200 تسليم. النقر على صف يعرض الحمولة وآخر خطأ.",
    allWebhooks: "كل الويب هوك",
    anyStatus: "أي حالة",
    noDeliveries: "لا تسليمات بعد.",
    columns: { when: "الوقت", webhook: "الويب هوك", event: "الحدث", status: "الحالة", attempts: "المحاولات", next: "التالي / النتيجة" },
    status: { Pending: "منتظر", Delivered: "تم التسليم", Failed: "فشل", Exhausted: "استنفدت المحاولات" },
    delivery: "التسليم",
    eventId: "معرف الحدث",
    deliveryId: "معرف التسليم",
    deliveredAt: "وقت التسليم",
    attemptsCount: "{{count}} محاولة", attemptsCount_zero: "لا محاولات", attemptsCount_one: "محاولة واحدة", attemptsCount_two: "محاولتان", attemptsCount_few: "{{count}} محاولات", attemptsCount_many: "{{count}} محاولة", attemptsCount_other: "{{count}} محاولة",
    case: "الحالة",
    lastError: "آخر خطأ",
    payload: "الحمولة",
    redeliver: "إعادة التسليم",
    deleteTitle: "حذف الويب هوك",
    deleteConfirm: "حذف «{{name}}» وسجل تسليماته؟",
    toasts: { created: "تم إنشاء الويب هوك.", saved: "تم حفظ الويب هوك.", deleted: "تم حذف الويب هوك.", enabled: "تم تفعيل الويب هوك.", disabled: "تم تعطيل الويب هوك.", testOk: "سلم الاختبار في {{ms}} مللي ثانية.", testFailed: "فشل تسليم الاختبار.", redelivered: "أدرج لإعادة التسليم." },
  },
  integrationsTabs: { monitor: "المراقبة", webhooks: "الويب هوك", connectors: "الموصلات", connectorsSoon: "يصل منشئ الموصلات مع الإصدار التالي من إدارة المنصة." },
  connectors: {
    title: "منشئ الموصلات",
    subtitle: "اتصالات REST وSOAP بأنظمة الإحصاء والبيانات المفتوحة والشركاء دون برمجة: مصادقة عبر مراجع الأسرار، وعمليات بطلبات قالبية وربط للاستجابة، وإطلاق عبر مجموعات التغيير. وتمنح الوكلاء والمساعدون والأتمتة العمليات بأسمائها.",
    new: "موصل جديد",
    search: "البحث في الموصلات…",
    count: "عدد الموصلات: {{count}}",
    emptyTitle: "لا توجد موصلات بعد", emptyBody: "أنشئ موصلا بواجهة إحصاءات أو بيانات مفتوحة أو نظام شريك، ليتمكن الوكلاء والمساعدون والأتمتة من استخدام عملياته.",
    operations: "العمليات",
    unused: "غير مستخدم بعد",
    usage: { agent: "الوكلاء: {{count}}", assistant: "المساعدون: {{count}}", automation: "الأتمتة: {{count}}" },
    usageKind: { agent: "وكيل", assistant: "مساعد", automation: "أتمتة" },
    kind: { Rest: "REST", Soap: "SOAP", Smtp: "SMTP", Sms: "رسائل SMS", InboundWebhook: "Webhook وارد", Mcp: "MCP", Database: "قاعدة بيانات" },
    tabs: { general: "عام", auth: "المصادقة", operations: "العمليات", resilience: "المرونة", environments: "البيئات", test: "اختبار", calls: "الاستدعاءات", code: "الشيفرة", versions: "النسخ" },
    create: {
      intro: "سم الموصل وحدد وجهته. تضبط العمليات والمصادقة والمرونة في المنشئ، ولا يعمل شيء قبل إطلاق النسخة.",
      namePlaceholder: "مثال: إحصاءات المركز الاتحادي",
      keyHint: "أحرف لاتينية صغيرة وأرقام و'-'. تشير إليه المنح والأتمتة: fcsc-statistics.key-indicators.",
      keyInvalid: "من 2 إلى 48 حرفا لاتينيا صغيرا أو رقما أو '-'، يبدأ بحرف.",
      created: "أنشئ الموصل كمسودة.",
      createOpen: "إنشاء وفتح",
    },
    fields: {
      name: "الاسم", value: "القيمة", label: "التسمية", labelAr: "التسمية (عربي)", default: "الافتراضي", example: "مثال", required: "إلزامي", addRow: "إضافة",
      descriptionPlaceholder: "معنى القيمة – يقرؤه النموذج عندما يملؤها.",
      kind: "النوع", owner: "الجهة المالكة", ownerHint: "الجهة التي تشغل النظام (المركز الاتحادي للتنافسية والإحصاء، بيانات…).",
      baseUrl: "العنوان الأساسي", baseUrlHint: "عنوان http(s) كامل. ابدأ بـ {{simulators}} لاستخدام المحاكيات في المنصة ({{url}}).",
      inboundPath: "المسار الوارد", inboundPathHint: "تستدعي الأنظمة الخارجية ‎/api/inbound/{path}.",
      inboundSecret: "سر التوقيع", inboundSecretHint: "اختياري؛ يوقع المستدعي المحتوى بهذا السر (HMAC).",
    },
    general: {
      connection: "الاتصال", connectionHint: "وجهة الموصل. ويمكن للبيئات تجاوز العنوان والترويسات.",
      identityHint: "كيف يظهر الموصل في القوائم والمراقبة وسجل الاستدعاءات.",
      descriptionHint: "ما هو النظام وما البيانات التي يوفرها – يراه الوكلاء والمساعدون بجانب كل عملية.",
      enabledHint: "يبقى الموصل المعطل في الفهرس لكن لا يمكن لأي وكيل أو مساعد أو أتمتة استدعاؤه.",
      usage: "من يستخدمه", usageHint: "الوكلاء والمساعدون والأتمتة المنشورة التي منحت عمليات هذا الموصل.",
    },
    auth: {
      title: "المصادقة", hint: "كيف يثبت كل استدعاء هويته. بيانات الاعتماد مراجع secret:// تحل وقت الاستدعاء – ولا تظهر القيم في أي تعريف أو تصدير أو سجل.",
      kindLabel: "الطريقة",
      kind: { None: "بدون", ApiKey: "مفتاح API", Basic: "أساسية (اسم مستخدم وكلمة مرور)", Bearer: "رمز Bearer", OAuth2ClientCredentials: "OAuth 2.0 بيانات اعتماد العميل", MutualTls: "TLS متبادل (شهادة عميل)", Hmac: "توقيع الطلب HMAC" },
      explain: {
        None: "لا تحمل الاستدعاءات بيانات اعتماد – للواجهات العامة مثل صندوق النقد الدولي والبنك الدولي.",
        ApiKey: "مفتاح ثابت يرسل في ترويسة (أو في سلسلة الاستعلام) مع كل استدعاء.",
        Basic: "اسم مستخدم وكلمة مرور في ترويسة HTTP Basic.",
        Bearer: "رمز طويل الأمد يرسل في Authorization: Bearer.",
        OAuth2ClientCredentials: "تطلب المنصة رمزا من عنوان الرموز بمعرف العميل وسره، وتحتفظ به حتى انتهاء صلاحيته، وترسله كرمز Bearer.",
        MutualTls: "تقدم المنصة شهادة عميل (PEM) أثناء مصافحة TLS.",
        Hmac: "يوقع محتوى كل طلب بسر مشترك (HMAC-SHA256) في ترويسة.",
      },
      field: { name: "اسم الترويسة أو المعامل", value: "المفتاح", in: "يرسل في", username: "اسم المستخدم", password: "كلمة المرور", token: "الرمز", tokenUrl: "عنوان الرموز", clientId: "معرف العميل", clientSecret: "سر العميل", scope: "النطاق", audience: "الجمهور", certificate: "الشهادة (PEM)", privateKey: "المفتاح الخاص (PEM)", secret: "السر المشترك", header: "ترويسة التوقيع" },
      fieldHint: { name: "مثال: X-API-Key", scope: "اختياري؛ نطاقات مفصولة بمسافات.", audience: "اختياري؛ تحتاجه بعض مزودات الهوية.", header: "افتراضيا X-Signature." },
      inHeader: "ترويسة", inQuery: "سلسلة الاستعلام",
      hasValue: "مضبوط", noValue: "بلا قيمة بعد", otherSecret: "مرجع سر آخر…",
      mustBeReference: "يجب أن يكون مرجع secret://، وليس القيمة نفسها.",
      secretsNote: "تحفظ الأسرار القيم مشفرة.", manageSecrets: "إدارة الأسرار",
      headers: "الترويسات الافتراضية", headersHint: "ترسل مع كل استدعاء (ويمكن للعمليات والبيئات الإضافة أو التجاوز). يمكن أن تستخدم القيم مراجع secret://.",
    },
    openapi: {
      open: "استيراد من OpenAPI", title: "استيراد العمليات من وصف OpenAPI",
      intro: "يرفع وصف OpenAPI (أو Swagger 2) للنظام أو يلصق بصيغة JSON. يصبح كل استدعاء عملية بمعاملاتها وقالب طلبها وربط استجابتها، وتكون استدعاءات GET للقراءة فقط.",
      file: "الملف", document: "الوصف (JSON)", tag: "العمليات الموسومة فقط بـ", tagHint: "اختياري. عند تركه فارغا تستورد جميع العمليات.",
      read: "قراءة الوصف", found: "العمليات الموجودة: {{found}}، الجديدة منها: {{fresh}}", more: "وعمليات أخرى: {{n}}", add: "إضافة العمليات ({{n}})",
    },
    ops: {
      title: "العمليات", hint: "كل عملية استدعاء واحد يمكن منحه للوكلاء والمساعدين والأتمتة.",
      untitled: "عملية بلا اسم", newName: "العملية {{n}}", copy: "نسخة", add: "إضافة عملية", duplicate: "تكرار", none: "لا توجد عمليات بعد.",
      emptyTitle: "لا توجد عمليات", emptyBody: "يمكن إضافة أول استدعاء يوفره هذا الموصل – مثل أحدث المؤشرات الرئيسية.",
      writes: "تغير البيانات في النظام الخارجي", health: "الفحص",
      call: "الاستدعاء", callHint: "سطر الطلب: الطريقة والمسار تحت العنوان الأساسي، وهل يقتصر الاستدعاء على القراءة.",
      keyHint: "من 2 إلى 48 حرفا لاتينيا صغيرا أو رقما أو '-'.",
      descriptionHint: "أخبر النموذج متى يستخدمها وماذا ترجع؛ هذا وصف الأداة الذي يراه الوكلاء والمساعدون.",
      method: "الطريقة", path: "المسار", pathHint: "يبدأ بـ '/'؛ تملأ {{placeholders}} من القيم أدناه.",
      timeout: "المهلة (مللي ثانية)", timeoutHint: "اختياري؛ يتجاوز مهلة الموصل.",
      readOnly: "للقراءة فقط", readOnlyHint: "لا يستدعي الوكلاء والأتمتة إلا عمليات القراءة؛ ويطلب المساعدون تأكيد المستخدم لما عداها.",
      idempotent: "آمنة للتكرار", idempotentHint: "يمكن إعادة المحاولة الفاشلة دون آثار جانبية (دائما لـ GET).",
      parameters: "القيم التي تأخذها", parametersHint: "كل {{placeholder}} مستخدم في المسار أو الاستعلام أو الترويسات أو المحتوى. ويمكن أن تستخدم القيم الافتراضية التواريخ المدمجة.",
      noParameters: "لا تأخذ هذه العملية أي قيم.", addParameter: "إضافة قيمة",
      missingParams: "مستخدمة وغير معرفة:", builtins: "المدمجة:",
      request: "الطلب", requestHint: "قيم الاستعلام والترويسات لهذا الاستدعاء؛ ويمكن أن تستخدم القيم {{placeholders}}.",
      query: "سلسلة الاستعلام", headers: "الترويسات", body: "قالب المحتوى", bodyHint: "JSON (أو XML لـ SOAP) مع {{placeholders}}.",
      response: "الاستجابة", responseHint: "يتم هنا اختيار حقول مسماة من الإجابة وتحويل مصفوفة إلى جدول (JSONPath: ‎$.data.items، ‎$.items[0].name).",
      mapping: "الحقول", mappingHint: "الاسم ← مسار JSONPath لقيمة واحدة (تاريخ البيانات، إجمالي…).",
      rowsPath: "الصفوف", rowsPathHint: "مسار JSONPath للمصفوفة التي تصبح جدولا؛ اتركه فارغا إن لم يكن هناك جدول.",
      columns: "الأعمدة", noColumns: "لا أعمدة: يأخذ الجدول كل حقول الصف الأول.", addColumn: "إضافة عمود", addStar: "كل الحقول الأخرى (*)",
      starHint: "العمود * يتوسع إلى كل حقول الصف غير المدرجة – للإجابات المفهرسة بالسنوات مثل صندوق النقد الدولي.",
    },
    resilience: {
      calls: "المهل وإعادة المحاولة", callsHint: "المدة المسموحة للاستدعاء وعدد مرات تكرار القراءة الفاشلة (بتراجع أسي).",
      timeout: "المهلة (مللي ثانية)", retries: "إعادة المحاولة", backoff: "التراجع (مللي ثانية)",
      retryNote: "لا يعاد إلا القراءة والعمليات الآمنة للتكرار؛ ولا تعاد استجابات 4xx عدا 408 و429.",
      breaker: "قاطع الدائرة", breakerHint: "بعد تكرار الفشل يتوقف الموصل عن استدعاء النظام لفترة، كي لا يبطئ شريك متعثر كل الوكلاء والصفحات.",
      threshold: "يفتح بعد (حالات فشل)", openFor: "يبقى مفتوحا (ثانية)",
      health: "فحص الصحة", healthHint: "عملية قراءة يستدعيها فحص المراقبة للتأكد من عمل النظام.", noHealth: "بدون – يستخدم الفحص العنوان الأساسي",
      logCalls: "تسجيل الطلبات والاستجابات", logCallsHint: "يحتفظ بملخص لكل استدعاء (مع إخفاء بيانات الاعتماد) لسجل الاستدعاءات والتدقيق.",
    },
    env: {
      title: "البيئات", hint: "عنوان وترويسات لكل بيئة؛ تعمل المنصة حاليا كـ '{{env}}'. وتستخدم البيئات دون تجاوزات إعدادات الموصل.",
      active: "نشطة", overridden: "متجاوزة", inherits: "تستخدم إعدادات الموصل", headers: "ترويسات إضافية",
    },
    test: {
      title: "اختبار عملية", hint: "يستدعي النسخة {{version}} عبر المنصة – بمصادقة حقيقية وإعادة محاولة وقاطع دائرة وسجل. ويمكن اختبار المسودات قبل الإطلاق.",
      operation: "العملية", environment: "البيئة", environmentHint: "أي عنوان وترويسات بيئة تستخدم (تعمل المنصة كـ '{{env}}').", platformEnvironment: "افتراضي المنصة ({{env}})",
      run: "تشغيل", saveAndRun: "حفظ وتشغيل", saveFirst: "تحفظ التغييرات غير المحفوظة قبل الاستدعاء.",
      writeWarning: "تغير هذه العملية البيانات في النظام الخارجي. اختبرها على بيئة تجريبية.",
      missing: "قيم مطلوبة: {{names}}", empty: "شغل عملية لرؤية الطلب والحقول المربوطة والجدول.",
      result: "HTTP {{status}} خلال {{ms}} مللي ثانية", ok: "نجح", failed: "فشل", attempts: "المحاولات: {{count}}",
      table: "الجدول ({{count}})", fields: "الحقول ({{count}})", request: "الطلب", raw: "الاستجابة الخام",
      noRows: "لا جدول: يلزم تحديد مسار الصفوف في العمليات ← الاستجابة.", noFields: "لا توجد حقول مربوطة.",
      masked: "تخفى بيانات الاعتماد فيما تعرضه المنصة وتسجله.",
      noOperations: "لا يوجد ما يختبر بعد", noOperationsBody: "يلزم أولا إضافة عملية من تبويب العمليات.",
    },
    calls: { title: "سجل الاستدعاءات", hint: "كل استدعاء عبر هذا الموصل – الاختبارات والوكلاء والمساعدون والأتمتة – الأحدث أولا.", live: "مباشر", none: "لا توجد استدعاءات بعد.", purpose: "الغرض · النسخة · البيئة" },
    grants: {
      none: "لا يوجد موصل منشور بعد.", build: "أنشئ موصلا في منشئ الموصلات.", open: "فتح الموصل", all: "كل العمليات",
      everything: "منح كل الموصلات ('*').", agentsRead: "الوكلاء للقراءة فقط: العمليات التي تغير البيانات للمساعدين وبتأكيد المستخدم.",
      allReadsOnly: "يستخدم الوكلاء عمليات القراءة فقط.", unknown: "غير موجودة في الفهرس (غير منشورة أو محذوفة):",
    },
    builder: {
      notFound: "الموصل غير موجود", notFoundBody: "لا يوجد موصل بالمفتاح '{{key}}'.", helpTitle: "منشئ الموصلات",
      summary: "{{operations}} عملية · {{auth}} · يستخدمه {{users}}",
      stageTitle: "موصل: {{name}}", stageBody: "تدخل النسخة مجموعة تغييرات للمراجعة؛ وبعد إطلاقها تستدعيها المنح والأتمتة.",
      publishedNotice: "هذه النسخة منشورة، ويلزم إنشاء نسخة جديدة لتعديلها؛ وتستمر المنشورة في العمل حتى إطلاق الجديدة.",
    },
    help: {
      what: "الموصل تعريف مرقم النسخ لكيفية استدعاء نظام خارجي: عنوانه ومصادقته وعملياته وإعدادات مرونته.",
      secrets: "بيانات الاعتماد مراجع secret:// إلى الإعدادات ← الأسرار، تحل وقت الاستدعاء؛ ولا تحتويها التصديرات ولا السجل.",
      grants: "يمنح الوكلاء والمساعدون العمليات بأسمائها (fcsc-statistics.key-indicators أو fcsc-statistics.*). الوكلاء للقراءة فقط، ويطلب المساعدون إذن المستخدم قبل أي استدعاء يغير البيانات. وتستخدم الأتمتة إجراء «استدعاء موصل».",
    },
    lint: {
      name: "يلزم إدخال اسم للموصل.",
      baseUrl: "يجب أن يكون العنوان الأساسي عنوان http(s) كاملا، أو يبدأ بـ {{simulators}}.",
      timeout: "المهلة بين 500 مللي ثانية و120 ثانية.", retries: "إعادة المحاولة بين 0 و5.", backoff: "التراجع بين 0 و30 ثانية.",
      breaker: "يفتح القاطع بعد 1 إلى 50 حالة فشل.", breakerOpen: "يبقى القاطع مفتوحا بين 5 ثوان وساعة.",
      authField: "تحتاج المصادقة إلى '{{field}}'.", authSecret: "يجب أن يكون '{{field}}' مرجع secret://.",
      health: "عملية فحص الصحة ليست من العمليات.", envUrl: "يجب أن يكون العنوان الأساسي لـ '{{env}}' عنوان http(s) كاملا.",
      inboundPath: "يحتاج Webhook الوارد إلى مسار.",
      noOperations: "لا توجد عمليات بعد – يحتاج الموصل عملية واحدة على الأقل قبل إطلاقه.",
      noColumns: "لإحدى العمليات مسار صفوف دون أعمدة: يأخذ جدولها كل حقول الصف الأول.",
      writes: "بعض العمليات تغير البيانات: لا يستدعيها الوكلاء والأتمتة، ويطلب المساعدون إذن المستخدم أولا.",
      opKey: "{{op}}: يجب أن يكون المفتاح من 2 إلى 48 حرفا لاتينيا صغيرا أو رقما أو '-'.", opDuplicate: "{{op}} معرفة مرتين.", opMethod: "{{op}}: طريقة غير معروفة.",
      opPath: "{{op}}: يبدأ المسار بـ '/'.", opTimeout: "{{op}}: المهلة بين 500 مللي ثانية و120 ثانية.",
      paramName: "{{op}}: تحتاج كل قيمة إلى اسم.", paramDuplicate: "{{op}}: قيمة معرفة مرتين.",
      undeclared: "{{op}}: {{tokens}} مستخدمة لكنها غير معرفة كقيمة.",
      mapping: "{{op}}: يحتاج الحقل '{{field}}' إلى مسار JSONPath مثل ‎$.data.value.", rowsPath: "{{op}}: يجب أن يكون مسار الصفوف JSONPath مثل ‎$.items.",
      column: "{{op}}: يحتاج العمود '{{column}}' إلى مسار JSONPath داخل الصف.", body: "{{op}}: قالب المحتوى ليس JSON صالحا.",
    },
  },
  forms: {
    title: "النماذج",
    subtitle: "نماذج قائمة على المخطط للتقديم وطلبات المعلومات والاعتراضات والاستخدام الداخلي. تصمم فيها الخطوات والحقول، ويضاف المنطق الشرطي وقواعد التحقق بين الحقول، وتستعرض باللغتين، ثم تدرج نسخة للإصدار.",
    newForm: "نموذج جديد",
    searchPlaceholder: "البحث في النماذج…",
    emptyTitle: "لا توجد نماذج بعد",
    emptyBody: "ابدأ من قالب أو استورد نموذجا مصدرا من نشر آخر. النماذج مرقمة النسخ؛ ولا تصل إلى مقدمي الطلبات إلا النسخ المطلقة.",
    noMatch: "لا توجد نماذج تطابق عوامل التصفية الحالية.",
    help: {
      what: "النموذج هو مخطط JSON (البيانات) مع مخطط واجهة (الخطوات والأقسام وترتيب الحقول والشروط) وقواعد JsonLogic. يعرض المستند نفسه في معالج البوابة وفي العرض للقراءة فقط في المكتب الخلفي وفي هذا المنشئ.",
      versions: "الحفظ يعدل المسودة الحالية. الإدراج يضيف المسودة إلى إصدار؛ وعند نشر الإصدار تصبح النسخة للقراءة فقط ويمكن بدء نسخة جديدة منها.",
      bindings: "الروابط تربط مسارات النموذج بمفاتيح عقد البيانات حتى يقرأ منطق الإجراء المجمع (الحدود والرسوم) الطلبات الناتجة من نموذج ديناميكي.",
    },
    stats: { total: "النماذج", totalHint: "مفاتيح النماذج المميزة", published: "منشورة", publishedHint: "لها نسخة حية", drafts: "مسودات", draftsHint: "قيد التحرير أو المراجعة", fields: "الحقول", fieldsHint: "عبر النسخ المعروضة" },
    filters: { published: "منشورة", hasDraft: "لها مسودة", inReview: "قيد المراجعة" },
    columns: { published: "المنشورة", draft: "المسودة", fields: "الحقول", usedBy: "تستخدمها" },
    purpose: { Intake: "تقديم", Rfi: "طلب معلومات", Objection: "اعتراض", Internal: "داخلي" },
    status: { Draft: "مسودة", InReview: "قيد المراجعة", Published: "منشورة", Retired: "متقاعدة" },
    tabs: { design: "التصميم", rules: "القواعد", preview: "المعاينة", code: "الكود", settings: "الإعدادات", versions: "النسخ" },
    create: {
      intro: "تبدأ العملية باختيار نقطة البداية وتسمية النموذج وتحديد مفتاحه. يمكن تغيير كل شيء لاحقا عدا المفتاح.",
      fromTemplate: "من قالب", fromTemplateHint: "فارغ أو استفسار أو إخطار صفقة.",
      import: "استيراد", importHint: "ملف .form.json مصدر من تبويب الكود.",
      importPrompt: "يلزم اختيار ملف .form.json مصدر من نشر آخر.", importReady: "تم التحميل – {{fields}} حقلا في المستوى الأعلى.", chooseFile: "اختيار ملف", fileLoaded: "تم تحميل {{name}}.",
      namePlaceholder: "مثال: إخطار اندماج – النموذج CD-F-01",
      keyInvalid: "أحرف لاتينية صغيرة وأرقام وشرطات؛ 2–64 حرفا؛ يبدأ بحرف.", keyTaken: "يوجد نموذج بهذا المفتاح.",
      createOpen: "إنشاء وفتح", created: "تم إنشاء النموذج.",
    },
    builder: {
      helpTitle: "منشئ النماذج",
      help: {
        design: "يمكن سحب العناصر من اللوحة إلى قسم، أو النقر على عنصر لإلحاقه بالقسم المحدد. والنقر على حقل يتيح تحرير تسميته والتحقق وخيارات العنصر والشروط في لوحة الخصائص.",
        rules: "القواعد شروط JsonLogic تمنع الإرسال (خطأ) أو تحذر عندما تتحقق. يمكنها مقارنة الحقول ببعضها واستخدام مساعدات الجداول (count, sum, any).",
        publish: "الحفظ يحتفظ بالمسودة. الإدراج للإصدار يضيفها إلى مجموعة تغييرات لاعتماد بأربع أعين. النسخ المنشورة غير قابلة للتعديل – ابدأ نسخة جديدة للتحرير.",
        shortcuts: "{{mod}}S حفظ · {{mod}}Z تراجع · ⇧{{mod}}Z إعادة · Delete يحذف الحقل المحدد.",
      },
      summary: "{{fields}} حقلا · {{steps}} خطوة · {{rules}} قاعدة",
      warnings: "{{count}} تحذير", warnings_zero: "لا تحذيرات", warnings_one: "تحذير واحد", warnings_two: "تحذيران", warnings_few: "{{count}} تحذيرات", warnings_many: "{{count}} تحذيرا", warnings_other: "{{count}} تحذير",
      undo: "تراجع", redo: "إعادة",
      save: "حفظ المسودة", stage: "إدراج للإصدار", discard: "تجاهل المسودة", newVersion: "نسخة جديدة", withdraw: "سحب من المراجعة",
      staged: "أضيفت المسودة إلى إصدار.", stageTitle: "النموذج: {{name}}",
      stageDialogTitle: "إدراج للإصدار", stageBody: "تحفظ المسودة وتضاف إلى مجموعة تغييرات. يعتمد مسؤول ثان الإصدار قبل أن يصبح حيا.",
      discardTitle: "تجاهل المسودة", discardBody: "تحذف نسخة المسودة. لا تتأثر النسخ المنشورة.", discarded: "تم تجاهل المسودة.",
      newVersionTitle: "بدء نسخة جديدة", newVersionBody: "ينشئ المسودة v{{version}} كنسخة من هذه النسخة. تحتفظ الحالات الجارية بالنسخة التي بدأت بها.", versionCreated: "تم إنشاء النسخة {{version}}.",
      withdrawn: "سحبت من المراجعة – المسودة قابلة للتحرير مجددا.",
      fixErrors: "يلزم إصلاح أخطاء التدقيق قبل الحفظ (عددها {{count}}).",
      inReviewNotice: "هذه النسخة قيد المراجعة ضمن إصدار. اسحبها للتحرير، أو انتظر قرار الإصدار.",
      publishedNotice: "هذه النسخة منشورة وللقراءة فقط. ابدأ نسخة جديدة لإجراء تغييرات.",
      notFound: "النموذج غير موجود", notFoundBody: "لا يوجد نموذج بالمفتاح «{{key}}».",
    },
    design: {
      paletteHint: "السحب إلى قسم أو النقر للإضافة", searchWidgets: "البحث في العناصر…", contentBlock: "نص إرشادي",
      addStep: "إضافة خطوة", addReviewStep: "إضافة خطوة مراجعة", reviewStep: "المراجعة", reviewStepHint: "ملخص لجميع الإجابات والإقرار، يعرض قبل الإرسال.",
      removeStep: "حذف الخطوة", addSection: "إضافة قسم", emptySection: "أفلت الحقول هنا", noSteps: "لا توجد خطوات بعد – إضافة خطوة تتيح بدء وضع الحقول.",
      noSectionForAdd: "يلزم إضافة قسم أولا.", columns: "{{count}} عمود", columns_zero: "لا أعمدة", columns_one: "عمود واحد", columns_two: "عمودان", columns_few: "{{count}} أعمدة", columns_many: "{{count}} عمودا", columns_other: "{{count}} عمود", conditional: "شرطي", conditionallyRequired: "مطلوب شرطيا",
      moveUp: "نقل لأعلى", moveDown: "نقل لأسفل", duplicate: "تكرار", place: "وضع", missingSchema: "مفقود في المخطط",
      unplaced: "حقول في المخطط غير موضوعة في أي خطوة: {{count}}", orphans: "حقول موضوعة لا توجد في المخطط: {{count}}",
      confirmRemoveField: "إزالة هذا الحقل من الخطوة؟ اختيار «موافق» يحذفه أيضا من المخطط، واختيار «إلغاء» يحتفظ بتعريف البيانات.",
      confirmRemoveSection: "إزالة هذا القسم وحقوله من الخطوة؟", confirmRemoveStep: "إزالة هذه الخطوة وجميع أقسامها؟",
    },
    widgetCategories: { basic: "أساسي", choice: "اختيار", number: "أرقام", date: "تواريخ", composite: "مركب", documents: "مستندات", layout: "تخطيط" },
    props: {
      nothingSelected: "اختيار خطوة أو قسم أو حقل يتيح تحرير خصائصه.",
      step: "الخطوة", section: "القسم", field: "الحقل",
      groups: { identity: "الهوية", validation: "التحقق", widget: "العنصر", behaviour: "السلوك", data: "البيانات" },
      stepTitle: "عنوان الخطوة", sectionTitle: "عنوان القسم", title: "العنوان", english: "الإنجليزية", arabic: "العربية",
      key: "المفتاح", keyHint: "اسم الخاصية في مخطط JSON والطلب. تغيير الاسم يحدث كل الإشارات.", keyErrors: { invalidKey: "أحرف وأرقام وشرطة سفلية؛ يجب أن يبدأ بحرف.", notFound: "الحقل غير موجود.", duplicateKey: "حقل آخر يحمل هذا المفتاح." },
      label: "التسمية", hint: "تلميح", help: "نص المساعدة", placeholder: "النص البديل", unit: "الوحدة", icon: "الأيقونة", iconHint: "اسم أيقونة Lucide (اختياري).",
      widget: "العنصر", format: "التنسيق", default: "القيمة الافتراضية", defaultHint: "تملأ مسبقا عند فتح النموذج.", pattern: "النمط (regex)", patternHint: "تعبير نمطي JavaScript بدون شرطات مائلة.",
      minLength: "أدنى طول", maxLength: "أقصى طول", minimum: "الحد الأدنى", maximum: "الحد الأقصى", multipleOf: "الخطوة", minItems: "أدنى عدد صفوف", maxItems: "أقصى عدد صفوف",
      options: "الخيارات", addOption: "إضافة خيار", optionValue: "القيمة", deprecated: "مهمل",
      visibleWhen: "مرئي عندما", visibleWhenHint: "الحقول المخفية لا تتحقق وتحذف من الطلب.", requiredWhen: "مطلوب عندما", requiredWhenHint: "بالإضافة إلى علامة «مطلوب» الثابتة.", disabledWhen: "معطل عندما",
      addCondition: "إضافة شرط", stepVisibleHint: "تخطي الخطوة كاملة ما لم يتحقق الشرط.",
      readOnly: "للقراءة فقط", sensitive: "حساس", sensitiveHint: "يحجب في عرض المكتب الخلفي وفي سياق الوكلاء.",
      span: "العرض", spanAuto: "تلقائي", spanHint: "عدد الأعمدة التي يشغلها الحقل في شبكة القسم.", columns: "الأعمدة", collapsible: "قابل للطي", collapsedByDefault: "مطوي افتراضيا",
      direction: "اتجاه النص", dirAuto: "تلقائي", binding: "ربط عقد البيانات", bindingHint: "المفتاح الذي يقرأ منه منطق الإجراء المجمع هذه القيمة.",
      declaration: "نص الإقرار", declarationHint: "يعرض مع مربع التأكيد في خطوة المراجعة.", reviewHint: "تعرض خطوة المراجعة كل حقل مجاب والإقرار.",
      nestedHint: "كائن متداخل – حرر عناصره الفرعية باختيارها في اللوحة.",
    },
    rules: {
      intro: "تعمل القواعد بين الحقول على العميل ثم مجددا على الخادم. القاعدة التي تتحقق تعني مخالفة.",
      add: "إضافة قاعدة", emptyTitle: "لا توجد قواعد بعد", emptyBody: "يمكن إضافة قاعدة لمقارنة الحقول ببعضها، مثل تاريخ الإتمام بعد تاريخ التوقيع أو الحصة السوقية المجمعة فوق حد معين.",
      when: "تنطلق عندما", condition: "الشرط", conditionHint: "يبنى هنا الشرط الذي يصف المخالفة، ويشار إلى حقل آخر بالرمز @.",
      target: "الحقل المبرز", targetHint: "حيث تظهر الرسالة.", wholeForm: "النموذج كاملا", severity: "الخطورة", error: "خطأ – يمنع الإرسال", warning: "تحذير – يعرض ولا يمنع",
      messageEn: "الرسالة (الإنجليزية)", messageAr: "الرسالة (العربية)", explanation: "التوضيح", explanationHint: "يعرض للمحررين وفي خطوة المراجعة.",
      firesOnSample: "تنطلق على العينة", passesOnSample: "تمر على العينة", fires: "تنطلق", passes: "تمر",
      testBench: "منصة الاختبار", testBenchHint: "تقيم على بيانات العينة المحفوظة (المعاينة ← حفظ كعينة).", noSample: "لا توجد بيانات عينة بعد. املأ المعاينة واختر «حفظ كعينة» لاختبار القواعد هنا.",
      operators: "المعاملات", operatorsHint: "JsonLogic القياسي مع مساعدات NCP، متاحة على العميل والخادم.",
    },
    preview: {
      wizard: "معالج", single: "صفحة واحدة", readonly: "للقراءة فقط", mobile: "هاتف", desktop: "سطح المكتب",
      clear: "مسح", loadSample: "تحميل العينة", saveAsSample: "حفظ كعينة", sampleSaved: "تم تحديث بيانات العينة – ويلزم حفظ المسودة للاحتفاظ بها.", submitted: "تم الإرسال (معاينة فقط).",
      clientValidation: "التحقق على العميل", clientHint: "Ajv والقواعد كما تعمل في البوابة.", serverValidation: "التحقق على الخادم", serverHint: "المستند نفسه يتحقق منه الخادم – يجب أن يتفق مع العميل.",
      runServer: "تحقق على الخادم", saveFirst: "يلزم حفظ المسودة أولا للتحقق على الخادم.", noIssues: "لا توجد مشكلات.", data: "بيانات الطلب",
      parityOk: "العميل والخادم متفقان.", parityDiff: "العميل يبلغ عن {{client}} أخطاء والخادم عن {{server}} – راجع الفروق.",
    },
    code: {
      parts: { schema: "مخطط JSON", uiSchema: "مخطط الواجهة", rules: "القواعد", bindings: "الروابط", sampleData: "بيانات العينة" },
      format: "تنسيق", validJson: "JSON صالح – مطبق", fieldCount: "{{count}} حقل", fieldCount_zero: "لا حقول", fieldCount_one: "حقل واحد", fieldCount_two: "حقلان", fieldCount_few: "{{count}} حقول", fieldCount_many: "{{count}} حقلا", fieldCount_other: "{{count}} حقل",
      clientLint: "التدقيق", clientLintHint: "فحوص بنيوية تعمل مباشرة أثناء الكتابة.", serverLint: "تدقيق الخادم", serverLintHint: "الفحوص نفسها على الخادم، بما فيها تجميع مخطط JSON.", runServerLint: "تشغيل تدقيق الخادم",
      serverFieldCount: "عدد الحقول لدى الخادم: {{count}}", countMismatch: "العميل يحصي {{client}}",
      importInvalid: "يجب أن يحتوي الملف على schema وuiSchema.", imported: "تم استيراد النموذج إلى المسودة.",
      xncpHint: "يحمل x-ncp العناوين ثنائية اللغة واختيار العنصر والتلميحات داخل المخطط؛ وتتجاهله مدققات JSON Schema القياسية.",
    },
    settings: {
      identity: "الهوية", keyHint: "معرف ثابت تستخدمه الخدمات والحزم.", purpose: "الغرض", purposeHint: "حيث يقدم النموذج: تقديم الطلبات، الرد على طلب معلومات، اعتراض، أو استخدام داخلي.",
      tags: "الوسوم", tagsHint: "تسميات حرة للبحث والتحزيم.", addTag: "إضافة وسم",
      bindings: "روابط عقد البيانات", bindingsHint: "اربط مسارات النموذج بالمفاتيح التي يقرأها منطق الإجراء المجمع من الطلب.", formPath: "مسار النموذج", contractKey: "مفتاح العقد", noBindings: "لا توجد روابط بعد.", addBinding: "إضافة",
      usedBy: "تستخدمها الخدمات", usedByHint: "الخدمات التي نموذج تقديمها هو هذا المفتاح.", notUsed: "لا تشير إليه أي خدمة بعد.",
      whereRendered: "حيث يعرض", whereRenderedHint: "يتشارك معالج البوابة لمقدمي الطلبات ولوحة بيانات الطلب في المكتب الخلفي هذا التعريف.", openBackoffice: "فتح المكتب الخلفي",
    },
    versions: {
      title: "السجل", emptyTitle: "لا توجد نسخ", emptyBody: "تظهر النسخ بعد حفظ النموذج.", editing: "مفتوح", publishedAt: "نشر {{at}}", updatedAt: "حدث {{at}}", changeSet: "الإصدار",
      compare: "مقارنة", onlyOne: "توجد نسخة واحدة فقط – لا شيء للمقارنة بعد.", summary: "الملخص",
    },
  },
  common: {
    key: "المفتاح",
    name: "الاسم",
    nameAr: "الاسم (بالعربية)",
    description: "الوصف",
    descriptionAr: "الوصف (بالعربية)",
    refresh: "تحديث",
    version: "النسخة",
    status: "الحالة",
    updated: "آخر تحديث",
    createdBy: "أنشأه",
    actions: "إجراءات",
    draft: "مسودة",
    inReview: "قيد المراجعة",
    published: "منشور",
    retired: "مسحوب",
    active: "نشط",
    inactive: "غير نشط",
    enabled: "مفعل",
    disabled: "معطل",
    yes: "نعم",
    no: "لا",
    none: "لا شيء",
    all: "الكل",
    search: "بحث",
    filter: "تصفية",
    create: "إنشاء",
    save: "حفظ",
    saving: "جار الحفظ…",
    saved: "تم الحفظ.",
    cancel: "إلغاء",
    delete: "حذف",
    duplicate: "نسخ",
    export: "تصدير",
    import: "استيراد",
    test: "اختبار",
    preview: "معاينة",
    publish: "نشر",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    done: "تم",
    edit: "تعديل",
    open: "فتح",
    copy: "نسخ",
    copied: "تم النسخ.",
    confirm: "تأكيد",
    required: "إلزامي",
    optional: "اختياري",
    loading: "جار التحميل…",
    empty: "لا شيء هنا بعد.",
    error: "حدث خطأ ما.",
    errorDetail: "لم يمكن إتمام الطلب. يرجى المحاولة مرة أخرى.",
    adminOnly: "يمكن لمسؤولي المنصة فقط تغيير هذا.",
    permissionDenied: "لا تملك صلاحية القيام بذلك.",
    changeNote: "ملاحظة التغيير",
    changeNoteHint: "سبب إجراء هذا التغيير – يظهر في سجل الإصدارات وسلسلة التدقيق.",
    json: "JSON",
    visual: "مرئي",
    code: "كود",
    diff: "الفروقات",
    history: "السجل",
    rollback: "التراجع",
    validate: "تحقق",
    valid: "صالح",
    invalid: "غير صالح",
    issues: "{{count}} مشكلة", issues_zero: "لا مشكلات", issues_one: "مشكلة واحدة", issues_two: "مشكلتان", issues_few: "{{count}} مشكلات", issues_many: "{{count}} مشكلة", issues_other: "{{count}} مشكلة",
    unsaved: "غير محفوظ",
    add: "إضافة",
    remove: "إزالة",
    change: "تغيير",
    clear: "مسح",
    builtIn: "مضمن",
  },
  solutions: {
    title: "الحلول",
    subtitle: "كل واجهة تخدمها المنصة: تطبيقات الويب، واللوحات المضمنة، والقنوات، والبوابات الخارجية. أين تفتح السجلات في كل منها، ومن يمكنه رؤيتها، وهل هي متاحة.",
    newSolution: "تسجيل حل",
    searchPlaceholder: "البحث بالاسم أو المفتاح…",
    noMatch: "لا يوجد حل يطابق عوامل التصفية",
    emptyTitle: "لم يسجل أي حل بعد",
    linkCount: "الروابط: {{count}}",
    usedBy: "مستخدم في",
    everywhere: "كل مساحات العمل",
    threadsMonth: "المحادثات هذا الشهر",
    notFound: "الحل غير موجود",
    notFoundBody: "لا يوجد حل بالمفتاح «{{key}}». ربما حذف.",
    help: {
      what: "الحل هو أي مكان يعمل فيه الأشخاص مع المنصة: المساعد الذكي، والمكتب الخلفي للقضايا، وبوابة المتعاملين، وتطبيق خاص بإدارة، وقناة Teams، أو بوابة خدمات إلكترونية خارجية. وتختار مساحات العمل ما تستخدمه منها.",
      links: "تحدد قوالب الروابط العميقة أين يفتح السجل في كل واجهة. تستخدم المساعد الذكي والمكتب الخلفي واللوحات المضمنة هذا السجل لتحديد الروابط، لذا فإن نقل واجهة إلى عنوان جديد تغيير واحد هنا.",
      health: "تفحص كل واجهة مفعلة لها عنوان كل خمس دقائق. وعند توقف واجهة أو عودتها يطلق الحدث solution.health.changed الذي يمكن لخطافات الويب والأتمتة الاستجابة له.",
    },
    probe: {
      all: "فحص الكل الآن",
      one: "فحص الآن",
      someDown: "واجهات لا تستجيب: {{count}}",
      allUp: "استجابت جميع الواجهات ({{count}})",
      up: "استجاب {{name}} خلال {{ms}} ملي ثانية",
      down: "{{name}} لا يستجيب",
    },
    stats: {
      surfaces: "الواجهات",
      surfacesHint: "المفعلة من إجمالي المسجل",
      healthy: "تستجيب",
      healthyHint: "عند آخر فحص",
      threads: "المحادثات",
      threadsHint: "بدأت من واجهة هذا الشهر",
      gated: "خلف علامة ميزة",
      gatedHint: "تطرح تدريجيا أو توقف بعلامة",
    },
    fields: {
      kind: "النوع",
      deepLinks: "الروابط العميقة",
      flag: "علامة الميزة",
      flagKey: "مفتاح العلامة",
      keyHint: "أحرف لاتينية صغيرة وأرقام وشرطات. يستخدم في المحادثات والروابط ولا يمكن تغييره لاحقا.",
      baseUrl: "العنوان الأساسي",
      baseUrlHint: "مكان الواجهة. تلحق به قوالب الروابط النسبية.",
      baseUrlBuiltIn: "تتبع الواجهات المدمجة إعدادات المنصة لهذه البيئة.",
      healthUrl: "عنوان فحص الحالة",
      healthUrlHint: "اختياري. بدونه يفحص العنوان الأساسي؛ ولا تفحص القنوات إلا عند تعيينه. يعد الرمزان 401 و403 استجابة سليمة.",
      handoff: "تسليم الدخول الموحد",
      handoffHint: "يصل الموظفون الذين يفتحون هذه الواجهة من واجهة أخرى وهم مسجلو الدخول (رمز لمرة واحدة). أوقفه للمواقع خارج المنصة.",
      adapter: "مفتاح المحول",
      adapterHint: "المحول على الخادم الذي ينقل المحادثات من هذه الواجهة وإليها.",
      icon: "الأيقونة",
      iconHint: "اسم أيقونة lucide، مثل AppWindow أو Globe أو MessagesSquare.",
      sortOrder: "ترتيب العرض",
      sortOrderHint: "الأرقام الأصغر تظهر أولا في القوائم والروابط.",
      enabledHint: "تختفي الواجهات المعطلة من القوائم والروابط فورا.",
    },
    kind: { WebApp: "تطبيق ويب", Embedded: "لوحة مضمنة", Channel: "قناة", ExternalPortal: "بوابة خارجية" },
    kindHint: {
      WebApp: "تطبيق ويب على المنصة يسجل فيه الموظفون أو المتعاملون الدخول.",
      Embedded: "لوحة المساعد داخل تطبيق آخر.",
      Channel: "قناة مراسلة مثل Teams أو البريد الإلكتروني.",
      ExternalPortal: "موقع يدار خارج المنصة، مثل بوابة الخدمات الإلكترونية.",
    },
    health: {
      title: "الحالة",
      hint: "تفحص كل خمس دقائق، وعند الطلب.",
      up: "متاح",
      down: "متوقف",
      unknown: "لم يفحص بعد",
      notProbed: "لا يفحص",
      noTarget: "لا يوجد ما يفحص: يلزم إضافة عنوان فحص (للقنوات) أو عنوان أساسي.",
      alerts: "تنشر تغيرات الحالة بالحدث solution.health.changed لخطافات الويب والأتمتة.",
    },
    flag: { missing: "العلامة غير منشأة", off: "متوقفة", on: "مفعلة", partial: "طرح بنسبة {{pct}}%" },
    create: {
      intro: "سجل تطبيقا أو لوحة أو قناة أو بوابة خارجية. تهيأ الروابط والصلاحيات والحالة بعد ذلك.",
      namePlaceholder: "مثال: الخدمات الإلكترونية للوزارة",
      keyInvalid: "من 2 إلى 64 حرفا لاتينيا صغيرا أو رقما أو شرطة، ويبدأ بحرف.",
      keyTaken: "يوجد حل بهذا المفتاح.",
      urlInvalid: "يلزم عنوان http(s) كامل.",
      created: "سجل الحل",
      createOpen: "تسجيل وتهيئة",
    },
    tabs: { general: "عام", connection: "الاتصال والحالة", access: "الوصول", links: "الروابط العميقة", embed: "التضمين", settings: "الإعدادات" },
    editor: {
      helpTitle: "تهيئة حل",
      nameRequired: "يحتاج الحل إلى اسم.",
      deleted: "حذف الحل",
      builtInHint: "هذه واجهة مدمجة: يتبع عنوانها البيئة ولا يمكن حذفها، لكن يمكنك تهيئة روابطها وصلاحياتها وعلامتها وفحص حالتها.",
      fromPackage: "مثبت من الحزمة «{{key}}». تبقى تغييراتك هنا حتى تثبت الحزمة مجددا.",
      identity: "الهوية",
      identityHint: "اسم الواجهة وطريقة ظهورها في القوائم والروابط.",
      usage: "الاستخدام",
      usageHint: "مساحات العمل التي تتضمن هذه الواجهة والمحادثات التي بدأت منها.",
      unused: "لا تتضمنها أي مساحة عمل بعد. أضفها من تبويب القدرات في مساحة العمل.",
      connection: "الاتصال",
      connectionHint: "مكان الواجهة وكيف يصل إليها الموظفون.",
      permissions: "الصلاحيات المطلوبة",
      permissionsHint: "يحتاج الشخص إلى كل صلاحية محددة ليرى هذه الواجهة وروابطها. اتركها فارغة لكل من يملك الوصول إلى مساحة العمل.",
      noPermissions: "لا توجد صلاحيات في الكتالوج.",
      flagHint: "اختياري. ما دامت العلامة موجودة ومتوقفة لشخص ما، تخفى الواجهة وروابطها عنه. العلامة غير الموجودة لا تخفي شيئا.",
      flagMissing: "لا توجد علامة بهذا المفتاح بعد، لذا لا يحجب شيء. أنشئها من الإعدادات ← علامات الميزات.",
      manageFlags: "إدارة علامات الميزات",
      deleteTitle: "حذف {{name}}؟",
      deleteInUse: "مساحات عمل ما زالت تستخدمه: {{workspaces}}. ستفقد روابطه فورا.",
      deleteBody: "تختفي روابطه فورا. وتبقى المحادثات التي بدأت منه.",
    },
    settings: {
      title: "الإعدادات",
      hint: "إعدادات خاصة بالواجهة بصيغة JSON تقرؤها الواجهة أو محولها.",
      notObject: "يجب أن تكون الإعدادات كائن JSON.",
      invalid: "صحح إعدادات JSON قبل الحفظ.",
      seedVersion: "تدير المنصة القيمة seedVersion للواجهات المدمجة؛ اتركها كما هي.",
    },
    links: {
      title: "قوالب الروابط العميقة",
      hint: "أين يفتح السجل في هذه الواجهة. تملأ العناصر النائبة للسجل والشخص، ويتحقق من كل رابط مقابل ما يحق له رؤيته.",
      add: "إضافة رابط",
      empty: "لا توجد روابط عميقة",
      emptyHint: "بدون روابط لن تشير السجلات إلى هذه الواجهة أبدا.",
      label: "التسمية",
      labelAr: "التسمية (بالعربية)",
      scope: "السجل",
      template: "القالب",
      placeholders: "إدراج:",
      preview: "معاينة:",
      fixFirst: "روابط تحتاج إلى تصحيح: {{count}}",
      problem: {
        key: "يجب أن يكون المفتاح من 2 إلى 64 حرفا لاتينيا صغيرا أو رقما أو شرطة، ويبدأ بحرف.",
        duplicate: "رابط آخر يستخدم هذا المفتاح.",
        label: "يلزم إضافة تسمية للرابط.",
        scope: "يلزم تحديد ما يشير إليه الرابط.",
        template: "يلزم إدخال قالب.",
        relative: "يلزم أن يبدأ العنوان بـ / (نسبة إلى العنوان الأساسي) أو أن يكون عنوان http(s) كاملا.",
        placeholder: "لا يمكن ملء العنصر {{name}} في رابط من نوع «{{scope}}».",
      },
    },
    scope: { home: "الرئيسية", workspace: "مساحة العمل", case: "قضية", matter: "معاملة", document: "مستند قضية", proposal: "مقترح ذكاء اصطناعي", thread: "محادثة", artifact: "مخرج", assistant: "مساعد" },
    embed: {
      react: "التضمين في تطبيق React",
      reactHint: "داخل تطبيق مغلف بـ ApiProvider وAuthProvider. تحفظ المحادثة تحت هذه الواجهة ويعاد استخدامها في الزيارة التالية.",
      rest: "أي تقنية أخرى",
      restHint: "الاستدعاءات نفسها عبر HTTP برمز موظف، لـ OutSystems وأدوات البرمجة المنخفضة والتطبيقات الأصلية.",
      disabled: "هذه الواجهة معطلة: لا يمكن فتح محادثات منها حتى تفعل.",
    },
  },
  workspaces: {
    title: "مساحات العمل",
    subtitle: "مساحة العمل هي إدارة أو وظيفة داخل المساعد الذكي: مساعدوها ومعرفتها وأدلتها وأعضاؤها، مع ميزانية خاصة وقائمة مراجعة.",
    newWorkspace: "مساحة عمل جديدة",
    searchPlaceholder: "البحث في مساحات العمل…",
    emptyTitle: "لا توجد مساحات عمل بعد",
    emptyBody: "أنشئ أول مساحة عمل لتمنح إدارة مساعديها ومجموعات معرفتها وأعضاءها.",
    noMatch: "لا توجد مساحة عمل تطابق المرشح.",
    notFound: "مساحة العمل غير موجودة",
    notFoundBody: "لا توجد مساحة عمل بالمفتاح «{{key}}». ربما حذفت أو أعيدت تسميتها.",
    help: {
      what: "تقسم مساحات العمل المساعد الذكي حسب الإدارة. كل ما يراه العضو — المساعدون والمعرفة والأدلة والمحادثات — محدود بمساحة العمل التي اختارها.",
      membership: "تأتي العضوية من أدوار المنصة (كل من يحمل أحد الأدوار المدرجة) أو من أعضاء صريحين يضافون هنا. يمكن للمالكين إدارة الأعضاء من المساعد الذكي نفسها.",
      budget: "تحد الميزانية الشهرية إنفاق النماذج عبر كل مساعدي مساحة العمل؛ تعرض النظرة العامة الإجمالي الجاري وتنبه عند 80%.",
    },
    kind: { Department: "إدارة", Function: "وظيفة" },
    tabs: { general: "عام", capabilities: "القدرات", modules: "تصميم المساحة", members: "الأعضاء", activity: "النشاط" },
    stats: {
      workspaces: "مساحات العمل",
      workspacesHint: "مفعلة في مبدل المساعد الذكي",
      members: "الأعضاء",
      membersHint: "الموظفون ذوو الوصول، عبر الأدوار أو العضوية الصريحة",
      threadsWeek: "محادثات هذا الأسبوع",
      threadsWeekHint: "المحادثات التي بدأت خلال آخر 7 أيام",
      spendMonth: "الإنفاق هذا الشهر",
      pendingHint: "مقترحات تنتظر المراجعة: {{count}}",
    },
    metrics: {
      assistants: "المساعدون",
      members: "الأعضاء",
      threads: "المحادثات",
      thisWeek: "هذا الأسبوع: {{count}}",
      thisWeekLabel: "هذا الأسبوع",
      spendMonth: "الإنفاق / الشهر",
      noBudget: "بلا ميزانية",
      pending: "للمراجعة",
      delegatedRuns: "تشغيلات الوكلاء",
      artifacts: "المخرجات",
      roles: "الأدوار",
    },
    fields: {
      keyHint: "معرف بأحرف صغيرة يستخدم في الروابط والحزم. لا يمكن تغييره لاحقا.",
      kind: "النوع",
      parent: "مساحة العمل الأم",
      parentHint: "اختياري. لا ترث المساحة الفرعية شيئا تلقائيا؛ تستخدم الأم للتجميع في المبدلات والتقارير.",
      icon: "الأيقونة",
      iconHint: "اسم أيقونة Lucide، مثل Scale أو Landmark أو Gavel.",
      color: "اللون",
      sortOrder: "ترتيب العرض",
      enabledHint: "تبقى مساحات العمل المعطلة في إدارة المنصة لكنها تختفي من مبدل المساعد الذكي.",
      monthlyBudget: "الميزانية الشهرية (دولار)",
      monthlyBudgetHint: "0 يعني بلا حد. يتوقف المساعدون عن الإجابة عند استنفاد الميزانية حتى بداية الشهر التالي.",
      defaultAssistant: "المساعد الافتراضي",
      defaultAssistantHint: "يفتح عندما يبدأ العضو محادثة جديدة دون اختيار مساعد.",
      defaultAssistantFirst: "أول مساعد في القائمة",
    },
    editor: {
      helpTitle: "تحرير مساحة عمل",
      identity: "الهوية",
      identityHint: "كيف تظهر مساحة العمل في المبدل وفي الصفحة الرئيسية.",
      budget: "الميزانية والاستخدام",
      budgetHint: "أرقام حية للشهر الحالي.",
      summary: "{{assistants}} مساعدين · {{members}} أعضاء · {{threads}} محادثات",
      fromPackage: "مثبتة من الحزمة {{key}}",
      openInWorkspace: "فتح في المساعد الذكي",
      nameRequired: "الاسم مطلوب.",
      deleteTitle: "حذف مساحة العمل؟",
      deleteBody: "ستزال «{{name}}». تحفظ المحادثات والمخرجات والمقترحات المنشأة فيها لكن لن يمكن الوصول إليها من المبدل.",
      deleted: "حذفت مساحة العمل.",
    },
    capabilities: {
      assistants: "المساعدون",
      assistantsHint: "المساعدون المنشورون الذين يمكن للأعضاء التحدث معهم. الأول هو الافتراضي ما لم يحدد غيره.",
      noAssistants: "لا مساعدين بعد — سيرى الأعضاء مساحة عمل فارغة.",
      knowledge: "مجموعات المعرفة",
      knowledgeHint: "المجموعات التي يمكن لمساعدي هذه المساحة البحث فيها. المجموعات على مستوى المنصة متاحة دائما.",
      playbooks: "الأدلة",
      playbooksHint: "الخدمات الداخلية (المسائل) التي يمكن بدؤها من المحادثة عبر /playbook.",
      noPlaybooks: "لا أدلة — يمكن للمساعدين الإجابة والصياغة لكن لا فتح مسائل.",
      solutions: "الحلول",
      solutionsHint: "واجهات الإدارة المرتبطة من المساعد الذكي (المكتب الخلفي، البوابات، التطبيقات المضمنة).",
    },
    members: {
      title: "الأعضاء",
      hint: "كل من يحمل أحد أدوار مساحة العمل عضو تلقائيا؛ يضاف الأعضاء الصريحون هنا أو من قبل مالكي المساحة.",
      workspaceRoles: "أدوار العضوية",
      workspaceRolesHint: "أدوار المنصة التي يكون حاملوها أعضاء في هذه المساحة.",
      roleMembers: "الأعضاء عبر الأدوار",
      roleMembersHint: "محسوبون من المستخدمين الذين يحملون أحد الأدوار أعلاه.",
      roleMembersSave: "الحفظ لإعادة العد",
      effective: "مجموع الأعضاء: {{count}} (أضيف منهم صراحة: {{explicit}}).",
      add: "إضافة عضو",
      addHint: "البحث في دليل الموظفين. لا يمكن إضافة المستخدمين الخارجيين إلى مساحات العمل.",
      searchPlaceholder: "البحث بالاسم أو البريد الإلكتروني…",
      owner: "مالك",
      ownerHint: "يدير المالكون الأعضاء وأتمتة المساحة من المساعد الذكي.",
      promote: "تعيين مالكا",
      demote: "إزالة الملكية",
      added: "أضيف {{name}}.",
      removed: "أزيل {{name}}.",
      addedBy: "أضافه {{name}} {{when}}",
      until: "حتى {{date}}",
      emptyTitle: "لا أعضاء صريحين",
      emptyBody: "تأتي العضوية حاليا من الأدوار فقط. إضافة شخص هنا تمنحه الوصول دون دور.",
    },
    activity: {
      since: "منذ {{date}}",
      threads: "المحادثات يوميا",
      threadsHint: "المحادثات الجديدة بحسب اليوم خلال آخر 30 يوما.",
      spend: "الإنفاق بحسب المساعد",
      spendHint: "تكلفة النماذج هذا الشهر المنسوبة إلى كل مساعد.",
      users: "الأعضاء الأكثر نشاطا",
      usersHint: "بحسب الرسائل المرسلة خلال آخر 30 يوما.",
      userStats: "{{threads}} محادثات · {{messages}} رسائل",
    },
    create: {
      intro: "سم الإدارة واختر النوع. يمكنك إضافة المساعدين والمعرفة والأعضاء مباشرة بعد ذلك.",
      namePlaceholder: "مثلا: السياسات الاقتصادية",
      keyInvalid: "يلزم استخدام 2–64 حرفا صغيرا وأرقاما وشرطات، مع البدء بحرف.",
      keyTaken: "هذا المفتاح مستخدم بالفعل.",
      createOpen: "إنشاء وفتح",
      created: "أنشئت مساحة العمل.",
    },
    picker: {
      selected: "المحددة: {{count}}",
      unknown: "غير معروف — لم يعد متاحا",
    },
  },
  assistants: {
    title: "المساعدون",
    subtitle: "المساعدون المحادثيون الذين يتحدث معهم الأعضاء في المساعد الذكي. لكل منهم شخصية، ويفوض العمل إلى الوكلاء، ويبحث في المعرفة، ويعمل ضمن ضوابط الحماية.",
    newAssistant: "مساعد جديد",
    searchPlaceholder: "البحث في المساعدين…",
    emptyTitle: "لا مساعدين بعد",
    emptyBody: "أنشئ مساعدا، وامنحه شخصية، وأضفه إلى مساحة عمل ليبدأ الأعضاء المحادثة.",
    noMatch: "لا مساعد يطابق المرشح.",
    help: {
      what: "المساعد تعريف مرقم النسخ: موجه النظام، والمفوضون، والأدوات، والمعرفة، وتوجيه النموذج، وضوابط الحماية. تشير مساحات العمل إلى المساعدين بالمفتاح.",
      versions: "تحرر المسودات بحرية؛ يفتح التمهيد مجموعة تغييرات تنشر النسخة عند الإطلاق. والنسخ المنشورة للقراءة فقط، ويلزم إنشاء نسخة جديدة لتغييرها.",
      test: "تتحدث منصة الاختبار مع النسخة التي تحررها تماما قبل نشرها، بصلاحياتك أنت.",
    },
    filters: { unpublished: "لم ينشر قط" },
    stats: {
      total: "المساعدون",
      totalHint: "مفاتيح المساعدين المتميزة، بكل النسخ",
      published: "منشورة",
      publishedHint: "حية في مساحة عمل واحدة على الأقل",
      drafts: "مسودات",
      draftsHint: "نسخ قيد التحرير أو المراجعة",
      threadsMonth: "محادثات هذا الشهر",
      threadsMonthHint: "الإنفاق {{spend}} هذا الشهر",
    },
    columns: {
      capabilities: "القدرات",
      capabilitiesValue: "{{delegates}} مفوضين · {{knowledge}} مجموعات",
      model: "النموذج",
      usage: "الاستخدام",
    },
    tabs: { persona: "الشخصية", capabilities: "القدرات", model: "النموذج والضوابط", test: "منصة الاختبار", code: "الشيفرة", versions: "النسخ" },
    tier: { Fast: "سريع", Reasoning: "استدلالي", Vision: "بصري" },
    tierHint: { Fast: "زمن استجابة منخفض للمحادثة والصياغة.", Reasoning: "أبطأ، أقوى في التحليل والمهام متعددة الخطوات.", Vision: "يفهم الصور والمستندات الممسوحة." },
    profile: { Standard: "قياسي", Strict: "صارم", Minimal: "أدنى" },
    profileHint: { Standard: "إخفاء البيانات الشخصية، الاستشهادات مطلوبة، تسجيل استدعاءات الأدوات.", Strict: "القياسي مع موافقة المراجع على كل مقترح وبلا أدوات خارجية.", Minimal: "التسجيل فقط — لمساعدي الصياغة الداخلية على مواد عامة." },
    sideEffect: { Read: "قراءة فقط", Personal: "شخصي", Confirm: "تأكيد", Reviewed: "مراجعة" },
    sideEffectHint: { Read: "بحث واستعلام وصياغة. لا يتغير شيء خارج المحادثة.", Personal: "يعدل تخطيط العضو أو مسودته الخاصة فورا مع إمكانية التراجع، ولا يتغير شيء مشترك.", Confirm: "قد يتصرف بعد تأكيد العضو على بطاقة في المحادثة.", Reviewed: "قد يقترح تغييرات تصل إلى صندوق الوارد لمراجع." },
    persona: {
      identity: "الهوية",
      identityHint: "كيف يقدم المساعد نفسه في المبدل وترويسة المحادثة.",
      prompt: "موجه النظام",
      promptHint: "التعليمات التي يتبعها النموذج في كل دور. صف الدور والنبرة وما يرفض وكيفية الاستشهاد بالمصادر.",
      promptPlaceholder: "أنت مساعد المنافسة في وزارة الاقتصاد…",
      chars: "{{count}} حرف", chars_zero: "لا أحرف", chars_one: "حرف واحد", chars_two: "حرفان", chars_few: "{{count}} أحرف", chars_many: "{{count}} حرفا", chars_other: "{{count}} حرف",
      greeting: "التحية",
      greetingHint: "تظهر أعلى المحادثة الجديدة.",
      disclaimer: "إخلاء المسؤولية",
      disclaimerHint: "السطر أسفل مربع الرسالة: ما تمثله الإجابات وما لا تمثله لهذه الإدارة (مثل «معلومات وليست استشارة قانونية»). اتركه فارغا لاستخدام السطر العام للمنصة.",
      greetingEn: "التحية (بالإنجليزية)",
      greetingAr: "التحية (بالعربية)",
      suggested: "مقترحات البدء",
      suggestedHint: "حتى ستة مقترحات تظهر في المحادثة الفارغة. الأيقونات أسماء Lucide.",
      noSuggested: "لا مقترحات بدء — تعرض المحادثة الفارغة التحية فقط.",
    },
    capabilities: {
      delegates: "المفوضون",
      delegatesHint: "الوكلاء الذين قد يفوض المساعد العمل إليهم. تلحق تشغيلاتهم بالمحادثة وتمر مقترحاتهم بالمراجعة.",
      tools: "الأدوات",
      toolsHint: "الدوال التي قد يستدعيها المساعد مباشرة. يبقى سقف الأثر الجانبي أدناه ساريا.",
      allTools: "كل الأدوات",
      allToolsHint: "كل أداة مسجلة حتى سقف الأثر الجانبي. تلتقط الأدوات الجديدة تلقائيا.",
      toolCount: "{{count}} أداة", toolCount_zero: "لا أدوات", toolCount_one: "أداة واحدة", toolCount_two: "أداتان", toolCount_few: "{{count}} أدوات", toolCount_many: "{{count}} أداة", toolCount_other: "{{count}} أداة",
      knowledge: "مجموعات المعرفة",
      knowledgeHint: "المجموعات التي يبحث فيها للاستشهاد. تضاف مجموعات مساحة العمل فوقها عند التشغيل.",
      playbooks: "الأدلة",
      playbooksHint: "الخدمات الداخلية التي قد يبدؤها المساعد عبر /playbook.",
    },
    model: {
      routing: "توجيه النموذج",
      routingHint: "الفئة والمزود اللذان تختارهما البوابة لهذا المساعد.",
      guardrails: "ضوابط الحماية",
      guardrailsHint: "إعدادات الميزانية والمراجعة والسلامة المطبقة في كل دور.",
      alwaysOn: "مفعل دائما: إخفاء البيانات الشخصية، فحص حقن الموجهات، سجل تدقيق لكل استدعاء أداة.",
    },
    fields: {
      keyHint: "معرف بأحرف صغيرة تستخدمه مساحات العمل والحزم.",
      tagsHint: "تسميات حرة للترشيح.",
      allowAttachments: "السماح بالمرفقات",
      allowVoice: "السماح بالإدخال الصوتي",
      enabledHint: "يبقى المساعدون المعطلون منشورين لكنهم مخفيون عن الأعضاء.",
      connectorOps: "عمليات الموصلات",
      connectorOpsHint: "استدعاءات التكامل الصادرة التي قد يجريها المساعد، بصيغة connector.operation.",
      maxSideEffect: "سقف الأثر الجانبي",
      maxSideEffectHint: "أخطر فئة أدوات يمكن لهذا المساعد استخدامها.",
      modelTier: "فئة النموذج",
      modelTierHint: "تختار البوابة المسار النشط لهذه الفئة.",
      modelId: "تجاوز النموذج",
      modelIdHint: "معرف نموذج محدد اختياري؛ اتركه فارغا لاتباع مسار الفئة.",
      provider: "المزود",
      providerHint: "التثبيت على مزود واحد لأسباب إقامة البيانات.",
      providerDefault: "افتراضي البوابة",
      temperature: "درجة الحرارة",
      temperatureHint: "0 حتمي؛ فوق 0.7 تتباين الإجابات بشكل ملحوظ.",
      maxOutputTokens: "الحد الأقصى لرموز الإخراج",
      historyWindow: "نافذة السجل",
      historyWindowHint: "الرسائل المحفوظة حرفيا؛ تلخص الأدوار الأقدم.",
      turnTokenBudget: "ميزانية الرموز لكل دور",
      turnTokenBudgetHint: "حد صارم للدور الواحد شاملا استدعاءات الأدوات.",
      monthlyBudget: "الميزانية الشهرية (دولار)",
      monthlyBudgetHint: "0 يعني أن ميزانية مساحة العمل وحدها تسري.",
      guardrailProfile: "ملف ضوابط الحماية",
      reviewerRole: "دور المراجع",
      reviewerRoleHint: "من يراجع المقترحات المقدمة عبر هذا المساعد.",
      reviewerRoleDefault: "افتراضي مساحة العمل",
      flagKey: "علم الميزة",
      flagKeyHint: "علم اختياري يجب أن يكون مفعلا ليظهر المساعد.",
    },
    lint: {
      name: "الاسم مطلوب.",
      prompt: "موجه النظام فارغ — سيجيب المساعد بالإعدادات الافتراضية فقط.",
      promptLong: "موجه النظام طويل جدا؛ فكر في نقل المواد المرجعية إلى مجموعة معرفة.",
      noCapabilities: "لا مفوضين ولا أدوات ولا معرفة — لا يمكن للمساعد سوى المحادثة.",
      temperature: "درجة حرارة فوق 1.0 تجعل الإجابات غير موثوقة.",
      tokens: "ميزانية الرموز لكل دور أقل من الحد الأقصى لرموز الإخراج.",
      history: "نافذة سجل أقل من 4 تفقد السياق بسرعة.",
      reviewer: "أدوات المراجعة مسموحة لكن لم يحدد دور مراجع؛ سيستخدم افتراضي مساحة العمل.",
    },
    test: {
      title: "منصة الاختبار",
      hint: "محادثة مع النسخة {{version}} ({{status}}) بصلاحياتك أنت.",
      badge: "اختبار",
      pinned: "مثبت على النسخة {{version}}",
      newThread: "محادثة اختبار جديدة",
      recent: "محادثات الاختبار الأخيرة",
      none: "لا محادثات اختبار بعد.",
      workspace: "سياق مساحة العمل",
      workspaceHint: "تضاف معرفة وأدلة هذه المساحة كما لو كنت عضوا.",
      savesFirst: "يلزم حفظ التغييرات أولا — تتحدث منصة الاختبار مع النسخة المحفوظة.",
      emptyTitle: "ابدأ محادثة اختبار",
      emptyBody: "لا تظهر الرسائل هنا أبدا في المساعد الذكي. استخدمها للتحقق من النبرة والاستشهادات وسلوك الأدوات قبل التمهيد.",
    },
    code: {
      hint: "التعريف الكامل بصيغة JSON. طبق لتحميله في المحرر؛ يرفض JSON غير الصالح.",
      apply: "تطبيق JSON",
      applied: "طبق JSON في المحرر.",
    },
    builder: {
      helpTitle: "منشئ المساعدين",
      help: { capabilities: "يعمل المفوضون كوكلاء بضوابط حمايتهم الخاصة؛ الأدوات استدعاءات دوال مباشرة محدودة بسقف الأثر الجانبي." },
      summary: "{{delegates}} مفوضين · {{tools}} أدوات · {{knowledge}} مجموعات · تستخدمه {{workspaces}} مساحات عمل",
      allTools: "الكل",
      notFound: "المساعد غير موجود",
      notFoundBody: "لا يوجد مساعد بالمفتاح «{{key}}».",
      notInWorkspace: "هذا المساعد ليس في أي مساحة عمل بعد — لا يمكن للأعضاء الوصول إليه.",
      stageTitle: "تمهيد «{{name}}» للإطلاق",
      stageBody: "تفتح مجموعة تغييرات بهذه النسخة. تنشر عند الإطلاق وتصبح النسخة التي يتحدث معها الأعضاء.",
    },
    create: {
      intro: "ابدأ من الصفر أو انسخ مساعدا موجودا، ثم شكل شخصيته وقدراته.",
      namePlaceholder: "مثلا: مساعد الشؤون القانونية",
      source: "البدء من",
      blank: "فارغ",
      blankHint: "شخصية فارغة، بلا قدرات.",
      duplicate: "نسخ",
      duplicateHint: "نسخ آخر نسخة من مساعد موجود.",
      keyInvalid: "يلزم استخدام 2–64 حرفا صغيرا وأرقاما وشرطات، مع البدء بحرف.",
      keyTaken: "هذا المفتاح مستخدم بالفعل.",
      createOpen: "إنشاء وفتح",
      created: "أنشئ المساعد.",
    },
  },
  agents: {
    title: "الوكلاء",
    subtitle: "وكلاء متخصصون يصوغون ويراجعون ويحللون في الملفات وفي المحادثات. تعرف الوكلاء القابلة للتهيئة هنا دون شيفرة، وتدرج إلى جانبها وكلاء المنافسة المبنية بالشيفرة.",
    newAgent: "وكيل جديد",
    searchPlaceholder: "البحث في الوكلاء…",
    emptyTitle: "لا وكلاء بعد",
    noMatch: "لا وكيل يطابق المرشح.",
    compiledHint: "مبني بالشيفرة (وكلاء المنافسة). تدار موجهاته وتقييماته وتكلفته في حوكمة الذكاء الاصطناعي.",
    inCode: "في الشيفرة",
    help: {
      what: "الوكيل القابل للتهيئة تعريف مرقم النسخ: تعليمات تنتهي بقائمة \"Output sections:\"، وقالب مهمة، والمعرفة التي يقرؤها، والأدوات التي يجوز له استدعاؤها، والمخرجات المنظمة، وما يترتب على الموافقة. تستدعيه مراحل الأدلة والمساعدون والأتمتة بمفتاحه.",
      compiled: "الوكلاء المبنية بالشيفرة لا تحرر هنا، بل في حوكمة الذكاء الاصطناعي حيث موجهاتها وتقييماتها وتكلفتها.",
      test: "تشغل منصة الاختبار النسخة التي تحررها تماما على ملف حقيقي أو على تكليف، عبر جميع ضوابط الحماية، وتسجل المسودة على التشغيل — فلا يودع شيء ولا ينشأ أي مقترح.",
    },
    kind: { Configurable: "قابل للتهيئة", Compiled: "مبني بالشيفرة" },
    filters: { unused: "غير مستخدم في أي مكان" },
    stats: {
      total: "الوكلاء",
      totalHint: "منها {{compiled}} مبنية بالشيفرة",
      configurable: "قابلة للتهيئة",
      configurableHint: "{{drafts}} منها لديها مسودة قيد العمل",
      runsMonth: "تشغيلات هذا الشهر",
      runsMonthHint: "الإنفاق {{spend}} هذا الشهر",
      acceptance: "نسبة القبول",
      acceptanceHint: "من {{proposals}} مقترح هذا الشهر",
    },
    columns: { kind: "النوع", usedBy: "يستخدمه", month: "هذا الشهر", monthValue: "{{runs}} تشغيل · {{spend}}", lastRun: "آخر تشغيل" },
    usage: { stages: "{{count}} مرحلة", stages_zero: "لا مراحل", stages_one: "مرحلة واحدة", stages_two: "مرحلتان", stages_few: "{{count}} مراحل", stages_many: "{{count}} مرحلة", stages_other: "{{count}} مرحلة", assistants: "{{count}} مساعد", assistants_zero: "لا مساعدين", assistants_one: "مساعد واحد", assistants_two: "مساعدان", assistants_few: "{{count}} مساعدين", assistants_many: "{{count}} مساعدا", assistants_other: "{{count}} مساعد" },
    tabs: { instructions: "التعليمات", grounding: "المعرفة والأدوات", steps: "الخطوات والوكلاء الفرعيون", output: "المخرجات والموافقة", model: "النموذج والميزانية", test: "منصة الاختبار", evaluation: "اختبارات الإطلاق", code: "الشيفرة", versions: "النسخ" },
    evaluation: {
      casesTitle: "حالات الاختبار",
      casesHint: "مدخل للوكيل (تكليف أو رقم ملف) وما يجب أن تقوله مسودته أو لا تقوله. حتى 12 حالة.",
      addCase: "إضافة حالة اختبار", newCase: "حالة الاختبار {{n}}", remove: "حذف حالة الاختبار", name: "اسم حالة الاختبار",
      noCases: "لا توجد حالات اختبار بعد", noCasesBody: "تلزم حالة واحدة على الأقل: التقييم والإصدار يحتاجان إليها.",
      brief: "التكليف", briefPlaceholder: "ما قد يطلبه الموظف من الوكيل…", matter: "رقم الملف", matterHint: "اختياري: التشغيل على هذا الملف.",
      contains: "يجب أن تقول المسودة", notContains: "يجب ألا تقول المسودة", listHint: "عبارة واحدة في كل سطر.",
      fields: "حقول المخرجات التي يجب ملؤها", fieldsHint: "مفاتيح مخطط المخرجات، تفصل بينها فواصل.", maxLength: "الحد الأقصى للطول (بالأحرف)",
      redTeamTitle: "حزمة الاختبار العدائي",
      redTeamHint: "تشغل في كل تقييم. ينجح الوكيل إذا لم يكشف تعليماته ولم يقترح اعتمادا، ولم يمرر بيانات شخصية خاما، ولم يقدم نصائح خارج مهمته.",
      probes: { injection: "حقن التعليمات", "personal-data": "تسريب البيانات الشخصية", "off-scope": "طلب خارج النطاق" },
      gateTitle: "بوابة الإطلاق",
      gateHint: "لن تعتمد الإصدارات هذه النسخة حتى ينجح آخر تقييم لها. تشغل كل حالة في بيئة معزولة: لا يحفظ شيء ولا يرسل.",
      run: "تشغيل تقييم النسخة {{version}}", running: "جار التشغيل في البيئة المعزولة (عدد التشغيلات: {{count}})…",
      passed: "ناجح", failed: "غير ناجح", never: "لم تقيم هذه النسخة بعد.",
      passedToast: "نجح التقييم: يمكن إصدار هذه النسخة.", failedToast: "لم ينجح التقييم: يعدل الوكيل أو الحالات ثم يعاد التشغيل.",
      score: "{{passed}}/{{total}} حالة · {{red}}/{{redTotal}} اختبار عدائي",
      runBy: "شغله {{name}} {{when}} في {{seconds}} ث",
      history: "تشغيلات سابقة لهذه النسخة",
      kind: { case: "حالة", redteam: "اختبار عدائي" },
    },
    onApprove: {
      title: "بعد الاعتماد",
      intro: "إجراءات تنفذ بعد أن يعتمد المراجع المسودة. تؤخذ القيم من الملف ومن المسودة المعتمدة.",
      add: "إضافة إجراء", none: "لا يحدث شيء آخر عند الاعتماد.", addValue: "إضافة قيمة", field: "الحقل", value: "القيمة", processTitle: "عنوان الملف الجديد",
      types: { record_create: "إنشاء سجل", letter_send: "إرسال خطاب", process_start: "بدء إجراء آخر" },
      choose: { record_create: "نوع السجل…", letter_send: "قالب الخطاب…", process_start: "الخدمة…" },
      map: { record_create: "حقول السجل", letter_send: "قيم الخطاب", process_start: "إجابات نموذج الطلب" },
      placeholders: "العناصر النائبة المتاحة:",
    },
    steps: {
      title: "الخطوات", hint: "تقسيم العمل إلى خطوات تنفذ بالترتيب، وترى كل خطوة نتائج ما سبقها، ثم يكتب الوكيل مسودته في النهاية.",
      add: "خطوة", newTitle: "الخطوة {{n}}", empty: "خطوة واحدة", emptyBody: "دون خطوات ينجز الوكيل المهمة دفعة واحدة. تضاف الخطوات للأعمال التي تتطلب جمعا أو تحققا أو مختصا أولا.",
      instruction: "المطلوب في هذه الخطوة", instructionPlaceholder: "مثال: احتساب حصة القطاع من الناتج المحلي والتوظيف من الأرقام الرسمية.",
      doneBy: "المنفذ", thisAgent: "هذا الوكيل", tools: "أدوات هذه الخطوة", toolsHint: "عند عدم التحديد: أدوات الوكيل نفسه.", handedTo: "محالة إلى {{agent}}",
      final: "الخطوة {{n}}: يكتب الوكيل المسودة من نتائج الخطوات، ثم يراجعها موظف مختص.",
      delegates: "الوكلاء الفرعيون المتاحون", delegatesHint: "يمكن للوكيل إحالة مهمة فرعية إلى هؤلاء الوكلاء أثناء العمل (كأداة). تعود مسوداتهم إليه، ولا يحال إلى المراجعة سوى مسودته.",
      moveUp: "نقل لأعلى", moveDown: "نقل لأسفل", remove: "إزالة",
    },
    instructions: {
      prompt: "التعليمات",
      promptHint: "دور الوكيل ومنهجه ومعاييره، ترسل موجها للنظام في كل تشغيل. اختمها بقائمة \"Output sections:\" من أسطر \"- عنوان\" — وتتبع كل مسودة تلك العناوين بترتيبها.",
      promptPlaceholder: "أنت صائغ السياسات في وزارة الاقتصاد…\n\nOutput sections:\n- الخلفية\n- الخيارات\n- التوصية",
      sectionsFound: "أقسام المخرجات التي عثر عليها: {{count}}",
      noSections: "لا توجد قائمة \"Output sections:\" — لن يكون للمسودات هيكل ثابت.",
      task: "قالب المهمة",
      taskHint: "ما يطلب من الوكيل في كل تشغيل. تملأ العناصر النائبة من الملف أو التكليف، وتبقي الكتل الشرطية النص المنطبق على المرحلة أو الدليل أو مصدر التشغيل فقط. النقر على رمز يدرجه.",
      placeholders: "العناصر النائبة",
      blocks: "الكتل الشرطية",
      appended: "إذا لم يضعها القالب، تلحق تلقائيا وقائع الملف والتكليف وقائمة المستندات، تليها المصادر المسترجعة قبل التشغيل.",
      unknownTokens: "العناصر النائبة غير المعروفة تترك فارغة:",
      unclosed: "كتل فتحت ولم تغلق:",
      identity: "الهوية",
      identityHint: "كيف يظهر الوكيل في الفهرس وعلى المقترحات وفي السجل الزمني للملف.",
      descriptionHint: "جملة واحدة عما ينتجه الوكيل — يقرؤها المساعدون عند تقرير التفويض.",
      tagsHint: "مفتاح مساحة العمل أولا (للتصفية)، ثم وسوم حرة.",
      enabledHint: "الوكلاء المعطلة تبقى منشورة لكن لا تشغلها سير العمل ولا المساعدون.",
      usage: "أين يعمل",
      usageHint: "مراحل الأدلة والمساعدون الذين يستدعون مفتاح هذا الوكيل، وفق التعريفات المنشورة.",
      unused: "لا شيء يستدعي هذا الوكيل بعد. أضفه إلى مرحلة في استوديو سير العمل أو إلى مفوضي أحد المساعدين.",
      stages: "مراحل الأدلة",
      assistants: "المساعدون",
      fromPackage: "مستورد من الحزمة {{key}}.",
    },
    grounding: {
      knowledge: "المعرفة",
      knowledgeHint: "مصادر الوكيل. تسترجع أقرب المقاطع قبل بدء النموذج، فيكون حتى التشغيل بلا أدوات مستندا إلى مصادر ومقرونا بالاستشهادات.",
      source: { matter: "معرفة الملف", "case-documents": "مستندات الملف", "legal-corpus": "مدونة قانون المنافسة" },
      sourceHint: {
        matter: "مجموعات دليل إجراء الملف والخيار المحدد (مثل قانون نوع التظلم)، أو مجموعات مساحة العمل عند التكليف من محادثة.",
        "case-documents": "المستندات المودعة في الملف، ويبحث فيها عبر search_case_documents.",
        "legal-corpus": "المرسوم بقانون اتحادي رقم 36 لسنة 2023 بشأن المنافسة وقراراته التنفيذية.",
      },
      collections: "مجموعات مسماة",
      collectionsHint: "يبحث فيها دائما أيا كان الملف.",
      tools: "الأدوات",
      toolsHint: "دوال حتمية قد يستدعيها النموذج أثناء التشغيل. تحجب الأدوات التي تتطلب ملفا عند التشغيل على تكليف.",
      auto: "مضافة من إعدادات المعرفة",
      autoNone: "لا شيء — فعل مصدرا للمعرفة لتمكين الوكيل من البحث.",
      needsCase: "تتطلب ملفا",
      connectorOpsHint: "استدعاءات التكامل الصادرة التي قد يجريها الوكيل، بصيغة connector.operation.",
    },
    output: {
      deliverable: "المخرج",
      deliverableHint: "يعيد كل تشغيل الغلاف نفسه، ويراه المراجع مقترحا.",
      kind: "نوع المقترح",
      kindHint: "يظهر للمراجعين وتستخدمه مرشحات صندوق الوارد (عنوان مخطط المخرجات).",
      sections: "الأقسام (من التعليمات)",
      noSections: "إضافة قائمة \"Output sections:\" في نهاية التعليمات تثبت هيكل المسودة.",
      envelope: "يعاد دائما",
      envelopeHint: "العنوان والملخص بالعربية والإنجليزية، والمسودة بصيغة markdown مع استشهادات [S#]، وما يصل إلى ست نقاط رئيسية، والأسئلة المفتوحة، ودرجة الإلحاح، ومستوى الثقة. أما البيانات المنظمة فاختيارية.",
      structured: "بيانات منظمة",
      structuredHint: "مخطط JSON اختياري لبيانات ترافق نص المسودة (تسلسل زمني، بطاقة تقييم، قائمة بنود). يراها المراجعون مع المسودة.",
      documentOnly: "لا بيانات منظمة — يعيد الوكيل مستندا فقط.",
      field: "الحقل",
      type: "النوع",
      approval: "الموافقة",
      approvalHint: "من يراجع المسودة وما يحدث عند موافقته. لا يودع شيء ولا يرسل دون تلك الموافقة.",
      reviewer: "المراجع",
      reviewerHint: "يوجه خيار \"دور المرحلة الحالية\" المقترح إلى من كلفه الدليل بالمهمة المفتوحة في المرحلة.",
      reviewerDefault: "الموظف الذي طلب، أو المسؤول عن الملف",
      actions: "عند الموافقة",
      actionsHint: "تجرب بالترتيب، ويقترح أول إجراء ينطبق على المسودة (الإيداع يتطلب ملفا، وإرسال الأسئلة يتطلب أسئلة مفتوحة ومستلما).",
      action: { matter_document_file: "إيداع المسودة في الملف", matter_rfi: "إرسال الأسئلة المفتوحة", matter_information_request: "إرسال الأسئلة المفتوحة", none: "تسجيل المسودة فقط" },
      recordOnly: "لا إجراء — تسجل الموافقة المسودة فقط.",
      moveUp: "نقل لأعلى",
      moveDown: "نقل لأسفل",
    },
    model: {
      routingHint: "الفئة التي تختارها البوابة لهذا الوكيل. تحتاج وكلاء الصياغة عادة إلى الفئة الاستدلالية.",
      temperatureHint: "أبقها منخفضة (0.1–0.3) للصياغة التي يجب أن تلتزم بالمصادر.",
      maxOutputTokensHint: "الحد الأعلى لطول المسودة، من 1,024 إلى 65,536.",
      guardrails: "الميزانية وضوابط الحماية",
      guardrailsHint: "حدود تطبق على كل تشغيل لهذا الوكيل.",
      runTokenBudget: "ميزانية الرموز لكل تشغيل",
      runTokenBudgetHint: "حد قاطع للتشغيل الواحد بما فيه استدعاءات الأدوات؛ الصفر يعني عدم وجود حد سوى ميزانية مساحة العمل.",
      monthlyBudgetHint: "الصفر يعني تطبيق ميزانية مساحة العمل وحدها.",
      alwaysOn: "مفعل دائما: إخفاء البيانات الشخصية، وفحص حقن الموجهات، والتحقق من الاستشهادات، ومراجعة جودة مستقلة، وموافقة بشرية على كل مخرج.",
    },
    lint: {
      name: "الاسم مطلوب.",
      temperature: "يجب أن تكون درجة الحرارة بين 0 و1.",
      tokens: "يجب أن يكون الحد الأقصى لرموز المخرجات بين 1,024 و65,536.",
      budget: "لا يجوز أن تكون الميزانيات سالبة.",
      runBudget: "ميزانية الرموز لكل تشغيل أقل من الحد الأقصى لرموز المخرجات.",
      schema: "يجب أن يكون مخطط المخرجات كائن JSON.",
      action: "إجراء (إجراءات) غير معروف: {{actions}}.",
      rfiFields: "يتطلب إرسال الأسئلة حقول الطلب التي تحمل اسم المستلم وبريده الإلكتروني، مثل grievantName,email.",
      prompt: "التعليمات فارغة — وهي مطلوبة قبل النشر.",
      sections: "لا تتضمن التعليمات قائمة \"Output sections:\".",
      ungrounded: "لا مصدر للمعرفة — سيصوغ الوكيل من المعرفة العامة فقط.",
      placeholders: "عناصر نائبة غير معروفة: {{tokens}}",
      blocks: "كتل فتحت ولم تغلق: {{blocks}}.",
    },
    test: {
      title: "منصة الاختبار",
      hint: "تشغيل النسخة {{version}} ({{status}}) في بيئة معزولة بصلاحياتك.",
      mode: { matter: "على ملف", brief: "على تكليف" },
      modeHint: { matter: "يقرأ الملف كما يقرؤه تشغيل المرحلة.", brief: "كأنه مفوض من محادثة." },
      matter: "الملف",
      matterHint: "أحدث ملفات الأدلة التي تستخدم هذا الوكيل.",
      noMatters: "لا يوجد ملف يستخدم أدلة هذا الوكيل بعد — اختبره على تكليف.",
      note: "ملاحظة الموظف (اختيارية)",
      noteHint: "تمرر بوصفها التكليف، كما يمرر طلب التعديل.",
      brief: "التكليف",
      briefHint: "ما قد يطلبه موظف في محادثة.",
      briefPlaceholder: "مثلا: صغ مذكرة سياسات بشأن الإعفاء من رسوم الترخيص لرائدات الأعمال.",
      workspaceHint: "تستخدم مجموعات معرفتها عندما يقرأ الوكيل معرفة الملف.",
      preview: "معاينة الموجه",
      run: "تشغيل في بيئة معزولة",
      queued: "أدرج التشغيل في الطابور — تظهر المسودة هنا عند اكتماله.",
      notStarted: "لم يبدأ التشغيل بعد. تحقق من أن العامل الخلفي يعمل.",
      savesFirst: "تحفظ التغييرات غير المحفوظة أولا — تشغل منصة الاختبار النسخة المحفوظة.",
      sandbox: "بيئة معزولة: تطبق ضوابط الحماية والتحقق من الاستشهادات ومراجعة الجودة؛ ولا يودع شيء ولا ينشأ مقترح ولا يتأثر السجل الزمني للملف.",
      recent: "تشغيلاتي التجريبية",
      none: "لا تشغيلات تجريبية بعد.",
      usage: "{{tokens}} رمزا · ${{cost}}",
      status: { Queued: "في الطابور", Running: "قيد التشغيل", Succeeded: "اكتمل", Failed: "فشل", Cancelled: "ألغي" },
      emptyTitle: "تجربة الوكيل",
      emptyBody: "يبدأ الاختبار باختيار ملف أو كتابة تكليف، ثم معاينة الموجه كما سيرسل، ثم تشغيله في البيئة المعزولة.",
      previewTitle: "معاينة الموجه",
      previewHint: "ما يرسله التشغيل قبل الاسترجاع واستدعاءات الأدوات. لا يستدعى أي نموذج.",
      renderedTask: "المهمة (بعد التعبئة)",
      showSteps: "عرض الخطوات ({{count}})",
      hideSteps: "إخفاء الخطوات",
      confidence: "الثقة {{value}}٪",
      reviewer: "المراجع: {{role}}",
      quality: "الجودة {{score}}/100",
      keyPoints: "النقاط الرئيسية",
      openQuestions: "الأسئلة المفتوحة",
      action: "الإجراء المقترح عند الموافقة",
      noAction: "لن يقترح أي إجراء — ستسجل الموافقة المسودة فقط.",
      unsupported: "ادعاءات لم يتمكن مدقق الاستشهادات من مطابقتها بمصدر",
      sources: "{{count}} مصدر", sources_zero: "لا مصادر", sources_one: "مصدر واحد", sources_two: "مصدران", sources_few: "{{count}} مصادر", sources_many: "{{count}} مصدرا", sources_other: "{{count}} مصدر",
      noDraft: "اكتمل التشغيل دون مسودة.",
    },
    create: {
      intro: "ابدأ من الصفر أو انسخ وكيلا قابلا للتهيئة يعمل جيدا، ثم شكل تعليماته ومعرفته ومخرجاته.",
      namePlaceholder: "مثلا: مراجع أثر التعرفة",
      source: "البدء من",
      blank: "فارغ",
      blankHint: "قالب المهمة الافتراضي، مع قراءة معرفة الملف ومستنداته.",
      duplicate: "نسخ",
      duplicateHint: "نسخ آخر نسخة من وكيل قابل للتهيئة.",
      keyHint: "المعرف الذي تستخدمه سير العمل والمساعدون والحزم. لا يمكن تغييره لاحقا.",
      keyInvalid: "يلزم استخدام من 2 إلى 64 حرفا صغيرا أو رقما أو نقطة أو شرطة سفلية أو شرطة، مع البدء بحرف.",
      keyTaken: "هذا المفتاح مستخدم بالفعل.",
      createOpen: "إنشاء وفتح",
      created: "أنشئ الوكيل.",
    },
    builder: {
      helpTitle: "منشئ الوكلاء",
      help: { template: "يعبأ قالب المهمة في كل تشغيل: تتوسع العناصر النائبة للملف والتكليف والمستندات إلى وقائع الملف، وتبقي كتل المرحلة والدليل والمعاملات النص المنطبق فقط." },
      summary: "{{sections}} قسم · {{knowledge}} مصدر معرفة · {{tools}} أداة · {{stages}} مرحلة · {{assistants}} مساعد",
      notFound: "الوكيل غير موجود",
      notFoundBody: "لا يوجد وكيل قابل للتهيئة بالمفتاح «{{key}}». تدار الوكلاء المبنية بالشيفرة في حوكمة الذكاء الاصطناعي.",
      compiledNotice: "يهيئ هذا التعريف الوكيل المبني بالشيفرة {{key}}: تحدد شيفرته المنهج، فلا يطبق إلا النموذج والميزانية.",
      publishedNotice: "هذه النسخة سارية: تستخدمها المراحل والمساعدون من تشغيلهم التالي، ويلزم إنشاء نسخة جديدة لتغييرها.",
      stageTitle: "تمهيد الوكيل «{{name}}» للإطلاق",
      stageBody: "تفتح مجموعة تغييرات بهذه النسخة. وعند الإطلاق تصبح النسخة التي تشغلها كل مرحلة وكل مساعد.",
    },
  },
  knowledge: {
    title: "المعرفة",
    subtitle: "مجموعات من المستندات يبحث فيها المساعدون ويستشهدون بها. تملكها المنصة أو مساحة عمل واحدة، مع مستوى ظهور يحدد من يمكنه قراءتها.",
    newCollection: "مجموعة جديدة",
    searchPlaceholder: "البحث في المجموعات…",
    emptyTitle: "لا مجموعات معرفة",
    emptyBody: "أنشئ مجموعة وحمل أول المستندات، أو ثبت حزمة إدارة.",
    noMatch: "لا مجموعة تطابق المرشح.",
    notFound: "المجموعة غير موجودة",
    notFoundBody: "لا توجد مجموعة بالمفتاح «{{key}}».",
    scope: { platform: "المنصة" },
    help: {
      what: "تجمع المجموعة مستندات (قوانين، قرارات، أدلة، سوابق) تقسم وتضمن ويبحث فيها للاستشهاد.",
      visibility: "المجموعات العامة يقرأها أي شخص في المساعد الذكي، والداخلية أعضاء المساحة المالكة، أما «للوكلاء فقط» فيبحث فيها ولا تستعرض أبدا.",
      sources: "تصل المستندات بالتحميل هنا أو في المساعد الذكي، أو من مكتبات SharePoint ومجلدات OneDrive وصفحات الويب التي تزامن وفق جدول أو عند الطلب.",
    },
    visibility: { Public: "عامة", Internal: "داخلية", AgentsOnly: "للوكلاء فقط" },
    visibilityHint: {
      Public: "يمكن لكل من سجل الدخول إلى المساعد الذكي استعراض هذه المستندات والاستشهاد بها.",
      Internal: "يستعرضها أعضاء المساحة المالكة فقط؛ يستشهد بها مساعدو تلك المساحة.",
      AgentsOnly: "لا تظهر أبدا في متصفح المعرفة؛ يبحث فيها المساعدون ويستشهدون بها.",
    },
    stats: {
      collections: "المجموعات",
      collectionsHint: "{{platform}} على مستوى المنصة",
      documents: "المستندات",
      documentsHint: "المستندات النشطة عبر كل المجموعات",
      chunks: "المقاطع",
      chunksHint: "المقاطع المضمنة المتاحة للاسترجاع",
      errors: "أخطاء الاستيعاب",
      errorsHint: "المجموعات التي فشل آخر استيعاب لها",
    },
    card: {
      documents: "{{count}} مستند", documents_zero: "لا مستندات", documents_one: "مستند واحد", documents_two: "مستندان", documents_few: "{{count}} مستندات", documents_many: "{{count}} مستندا", documents_other: "{{count}} مستند",
      chunks: "{{count}} مقطع", chunks_zero: "لا مقاطع", chunks_one: "مقطع واحد", chunks_two: "مقطعان", chunks_few: "{{count}} مقاطع", chunks_many: "{{count}} مقطعا", chunks_other: "{{count}} مقطع",
      error: "خطأ في الاستيعاب",
      usedBy: "تستخدمها {{workspaces}} مساحات عمل · {{assistants}} مساعدين",
      lastDocument: "آخر مستند {{when}}",
    },
    fields: {
      keyHint: "معرف بأحرف صغيرة تشير إليه مساحات العمل والمساعدون والحزم.",
      owner: "المالك",
      ownerHint: "مجموعات المنصة متاحة لكل مساحة عمل؛ مجموعات مساحة العمل تخص إدارة واحدة.",
      visibility: "الظهور",
      defaultKind: "نوع المستند الافتراضي",
      uploadRoles: "أدوار التحميل",
      uploadRolesHint: "الأدوار المسموح لها بالتحميل من المساعد الذكي. يمكن لمستخدمي إدارة المنصة ذوي صلاحية كتابة المعرفة التحميل دائما.",
      enabledHint: "تتجاوز المجموعات المعطلة في الاسترجاع وتخفى عن المتصفحات.",
    },
    editor: {
      helpTitle: "تحرير مجموعة",
      summary: "{{documents}} مستندات · {{chunks}} مقاطع · {{owner}}",
      settings: "الإعدادات",
      settingsHint: "الهوية والملكية ومن يمكنه القراءة أو التحميل.",
      usedBy: "يشير إليها",
      usedByHint: "مساحات العمل والمساعدون الذين يبحثون في هذه المجموعة.",
      noWorkspaces: "لا مساحة عمل تدرج هذه المجموعة.",
      noAssistants: "لا مساعد يدرج هذه المجموعة.",
      refresh: "إعادة العد",
      ingestionError: "فشل آخر استيعاب: {{error}}",
      deleteTitle: "حذف المجموعة؟",
      deleteBody: "ستزال «{{name}}» ومستنداتها من الاسترجاع. سيتوقف المساعدون المستشهدون بها عن إيجاد هذه المصادر.",
      deleted: "حذفت المجموعة.",
    },
    documents: {
      title: "المستندات",
      hint: "كل ما في المجموعة، مبدئيا أو محملا. إزالة مستند تحذف مقاطعه.",
      search: "البحث في المستندات…",
      kind: "النوع",
      document: "المستند",
      chunks: "المقاطع",
      includeInactive: "عرض المعطلة",
      seeded: "مبدئي",
      emptyTitle: "لا مستندات",
      emptyBody: "حمل ملف PDF أو DOCX أو نصيا ليصبح قابلا للبحث.",
      upload: "تحميل مستند",
      uploadHint: "إلى «{{name}}». تقرأ ملفات PDF الممسوحة ضوئيا؛ يقسم النص ويضمن فورا.",
      dropHint: "اختيار ملف (PDF أو DOCX أو TXT أو MD أو صورة)",
      titleEn: "العنوان (بالإنجليزية)",
      titleAr: "العنوان (بالعربية)",
      issuer: "الجهة المصدرة",
      issuedOn: "تاريخ الإصدار",
      sourceUrl: "رابط المصدر",
      uploaded: "استوعب «{{title}}» — {{chunks}} مقاطع.",
      removeConfirm: "إزالة «{{name}}» ومقاطعه من المجموعة؟",
      removed: "أزيل المستند.",
      syncedHint: "يودعه هذا المصدر ويبقيه محدثا",
      withdrawn: "مسحوب",
    },
    sources: {
      title: "المصادر",
      hint: "مكتبات SharePoint ومجلدات OneDrive وصفحات الويب والمواقع المزحوفة ولقطة المصادر الاقتصادية المجمعة التي تبقى متزامنة مع هذه المجموعة.",
      add: "إضافة مصدر",
      editTitle: "تعديل «{{name}}»",
      dialogIntro: "تقرأ المستندات الموجودة في المصدر وتقسم وتضمن. يعاد قراءة الملفات المعدلة، وتسحب الملفات التي تغادر المصدر.",
      empty: "لا مصدر متزامن. تصل المستندات بالتحميل فقط.",
      saveFirst: "يلزم حفظ المجموعة قبل المزامنة: تقرأ عمليات التشغيل المصادر المحفوظة.",
      collectionDisabled: "المجموعة معطلة، لذا لا تتزامن مصادرها.",
      noRecentRun: "لا تشغيل حديث",
      syncNow: "زامن الآن",
      queued: "تجري مزامنة «{{name}}».",
      removeConfirm: "إزالة المصدر «{{name}}»؟ تبقى المستندات التي أودعها في المجموعة حتى تزيلها.",
      keyLocked: "ثابت: المستندات التي أودعها هذا المصدر تشير إليه.",
      test: "اختبار المصدر",
      apply: "تطبيق",
      previewFailed: "تعذرت قراءة المصدر",
      previewSummary: "عثر على {{total}} عنصر، يمكن قراءة {{supported}} منها",
      previewFirst: "تعرض أول {{count}}",
      unsupported: "غير قابل للقراءة",
      kind: { upload: "التحميل اليدوي", url: "صفحات ويب", crawl: "موقع مزحوف", snapshot: "لقطة المصادر المجمعة", sharepoint: "مكتبة SharePoint", onedrive: "مجلد OneDrive" },
      kindHint: {
        url: "صفحات https عامة أو ملفات PDF أو Word",
        crawl: "موقع تتبع روابطه من صفحات البداية",
        snapshot: "المنشورات المجمعة مع البيانات الاقتصادية",
        sharepoint: "مكتبة مستندات في موقع فريق",
        onedrive: "مجلد في OneDrive لأحد المستخدمين",
      },
      namePlaceholder: { url: "مثال: صفحات منهجية الإحصاءات", crawl: "مثال: مكتبة تقارير الوزارة", snapshot: "مثال: المنشورات المجمعة", sharepoint: "مثال: سجل الآراء", onedrive: "مثال: أوراق وحدة السياسات" },
      fields: {
        urls: "العناوين",
        urlsHint: "عنوان في كل سطر، حتى 50. تقرأ الصفحات نصا دون القوائم والتذييلات؛ وتقرأ روابط PDF وWord ملفات.",
        startUrls: "صفحات البداية",
        startUrlsHint: "صفحة في كل سطر، حتى 10. تتبع روابط الموقع نفسه فقط، ضمن ملف robots.txt، وطلبا واحدا في كل مرة.",
        depth: "عمق الروابط",
        depthHint: "0 يقرأ صفحات البداية فقط؛ 1 وروابطها أيضا؛ 2 وروابط تلك الروابط.",
        maxItems: "الحد الأقصى للعناصر",
        maxItemsHint: "حتى 300 صفحة وملف في كل تشغيل.",
        include: "الاحتفاظ بالعناوين المطابقة",
        includeHint: "نمط في كل سطر: نص يحتويه العنوان، أو نمط يتضمن * (مثل *.pdf). إذا ترك فارغا تحفظ كل صفحة يوصل إليها.",
        exclude: "تخطي العناوين المطابقة",
        excludeHint: "لا تحفظ ولا تتبع (مثل /news/ أو *login*).",
        snapshotCollection: "ملف مستندات اللقطة",
        snapshotCollectionHint: "المنشورات المجمعة المحزومة لهذا الموضوع (data/economic-sources/documents). تودع اللقطة الجديدة في التشغيل التالي، وتتخطى المستندات التي لم تتغير.",
        connector: "موصل Microsoft Graph",
        connectorHint: "اتصال منشئ الموصلات الذي يملك تسجيل التطبيق المخول بقراءة الموقع أو المساحة.",
        siteUrl: "عنوان الموقع",
        library: "المكتبة",
        libraryHint: "اسم مكتبة المستندات، وغالبا «Documents».",
        user: "مالك OneDrive",
        userHint: "البريد الإلكتروني للمالك أو اسم المستخدم الأساسي.",
        folder: "المجلد",
        folderHint: "اتركه فارغا للمكتبة أو المساحة كاملة.",
        recursive: "المجلدات الفرعية",
        recursiveHint: "تضمين المجلدات الفرعية",
        documentKind: "إيداع المستندات بنوع",
        issuerHint: "يظهر في الاستشهادات؛ ويكون افتراضيا اسم المصدر.",
        schedule: "الجدول",
        scheduleHint: "بتوقيت الإمارات. تلتقط المصادر المستحقة خلال خمس دقائق.",
      },
      schedule: { manual: "يدوي فقط", hourly: "كل ساعة", daily: "يوميا 03:00", weekly: "أيام الاثنين 04:00", monthly: "شهريا، اليوم 1 الساعة 03:00", custom: "مخصص (cron)" },
      errors: {
        keyRequired: "أعط المصدر مفتاحا.",
        cron: "تعبير cron من خمسة حقول: الدقيقة الساعة اليوم الشهر يوم الأسبوع.",
        address: "«{{url}}» ليس عنوان https.",
        startUrls: "يلزم إدخال صفحة بداية واحدة على الأقل وعشر صفحات على الأكثر.",
        maxItems: "بين 1 و300.",
      },
    },
    runs: {
      title: "سجل المزامنة",
      hint: "كل عملية مزامنة أو إعادة تضمين، مع ما أودعته. النقر على عملية يعرض سجل عناصرها.",
      reembed: "إعادة تضمين الكل",
      reembedConfirm: "إعادة حساب تضمينات جميع المستندات وعددها {{documents}}؟ ويستخدم ذلك بعد تغيير نموذج التضمين.",
      reembedQueued: "بدأت إعادة التضمين.",
      reembedAll: "إعادة التضمين",
      emptyTitle: "لا عمليات بعد",
      emptyBody: "تظهر العمليات هنا عند مزامنة مصدر أو إعادة تضمين المجموعة.",
      source: "المصدر",
      statusLabel: "الحالة",
      result: "النتيجة",
      when: "الوقت",
      noChanges: "لا تغييرات",
      inProgress: "العملية ما زالت جارية…",
      noItems: "لم تسجل العملية أي عنصر.",
      detailSummary: "{{trigger}} · {{who}} · {{when}}",
      seen: "العناصر في المصدر: {{count}}",
      chunks: "المقاطع المضمنة: {{count}}",
      durationMs: "{{value}} ملي ثانية",
      durationS: "{{value}} ث",
      durationMin: "{{value}} د",
      status: { Queued: "في الانتظار", Running: "قيد التشغيل", Succeeded: "نجحت", PartiallySucceeded: "نجحت جزئيا", Failed: "فشلت" },
      trigger: { Manual: "يدوي", Schedule: "مجدول", Reembed: "إعادة تضمين" },
      count: { added: "أضيف {{count}}", updated: "حدث {{count}}", unchanged: "دون تغيير: {{count}}", removed: "سحب {{count}}", failed: "فشل {{count}}", reembedded: "أعيد تضمين {{count}}" },
      action: { added: "أضيف", updated: "حدث", unchanged: "دون تغيير", removed: "سحب", skipped: "تخطي", failed: "فشل", reembedded: "أعيد تضمينه" },
    },
    create: {
      intro: "سم المجموعة وحدد مالكها ومن يمكنه قراءتها. حمل المستندات مباشرة بعد ذلك.",
      namePlaceholder: "مثلا: قانون المنافسة",
      keyInvalid: "يلزم استخدام 2–64 حرفا صغيرا وأرقاما وشرطات، مع البدء بحرف.",
      keyTaken: "هذا المفتاح مستخدم بالفعل.",
      createOpen: "إنشاء وفتح",
      created: "أنشئت المجموعة.",
    },
  },
  automations: {
    title: "الأتمتة",
    subtitle: "قواعد تستجيب لأحداث المنصة أو تعمل وفق جدول زمني: أتمتة المنصة التي تعد هنا وتطلق عبر مجموعات التغيير، وأتمتة مساحات العمل المشتركة مع إدارة ما، والمراقبات الشخصية التي ينشئها الموظفون من المحادثة.",
    new: "أتمتة جديدة",
    searchPlaceholder: "البحث بالاسم أو المفتاح أو المالك",
    emptyTitle: "لا توجد أتمتة بعد",
    emptyBody: "أنشئ أتمتة للمنصة أو لمساحة عمل هنا. ويمكن للموظفين أيضا إعداد مراقبات شخصية من أي محادثة في المساعد الذكي.",
    noMatch: "لا توجد أتمتة تطابق عوامل التصفية الحالية.",
    neverRan: "لم تعمل بعد",
    runCount: "{{runs}} تشغيل",
    tabs: { list: "الأتمتة", runs: "سجل التشغيل", design: "التصميم", code: "الشيفرة", versions: "النسخ" },
    stats: {
      platform: "المنصة", platformHint: "تعد في إدارة المنصة وتطلق بعد الاعتماد",
      workspace: "مساحات العمل", workspaceHint: "مساحات العمل المستفيدة: {{count}}",
      personal: "المراقبات الشخصية", personalHint: "أنشأها الموظفون من المحادثة",
      runsWeek: "تشغيلات هذا الأسبوع", failedWeek: "الإخفاقات: {{count}}",
    },
    scope: { Platform: "المنصة", Workspace: "مساحة عمل", Personal: "شخصية" },
    state: { on: "مفعلة", paused: "متوقفة مؤقتا" },
    filters: { on: "مفعلة", paused: "متوقفة مؤقتا", draft: "مسودة أو قيد المراجعة", failing: "أخفق آخر تشغيل" },
    columns: { automation: "الأتمتة", scope: "النطاق", when: "عند", then: "ثم", lastRun: "آخر تشغيل" },
    runStatus: { Succeeded: "نجح", Failed: "أخفق", Skipped: "تم التخطي", DryRun: "تشغيل تجريبي" },
    priority: { Low: "منخفضة", Medium: "متوسطة", High: "عالية", Critical: "حرجة" },
    setField: { priority: "الأولوية", summary: "الملخص" },
    help: {
      what: "تنتظر الأتمتة أمرا ما — حدثا مثل فتح ملف أو اقتراب موعد نهائي، أو جدولا زمنيا، أو تشغيلا يدويا، أو Webhook واردا — ثم تتحقق من شرط اختياري وتنفذ حتى عشرة إجراءات بالترتيب.",
      scopes: "يمكن لأتمتة المنصة اتخاذ أي إجراء ولا تعمل إلا عبر مجموعة تغييرات. وتتبع أتمتة مساحة العمل إدارة واحدة ويمكنها الإشعار وتشغيل الوكلاء وفتح الملفات وفق الأدلة الإجرائية. أما المراقبات الشخصية فتعمل لصاحبها فقط.",
      condition: "الشرط تعبير JsonLogic يقيم على الحدث والملف المعني (الأولوية، دليل الإجراء، المرحلة، الأيام المتبقية…). اتركه فارغا للتشغيل في كل مرة.",
      safety: "لا يمكن للأتمتة أن تشغل بعضها بعضا لأكثر من ثلاثة مستويات، ولا تبدأ التشغيلات الناتجة عن أتمتة وكلاء أو أدلة إجراءات. ويسجل التشغيل التجريبي ما كان سيحدث دون تغيير أي شيء.",
    },
    create: {
      intro: "ابدأ بالاسم ومكان تطبيق الأتمتة؛ وتختار المشغل والشرط والإجراءات في المحرر.",
      namePlaceholder: "مثال: تصعيد المواعيد النظامية الفائتة",
      keyHint: "معرف ثابت يستخدم في مجموعات التغيير والحزم وسجل التشغيل.",
      scopeHint: {
        Platform: "أي إجراء؛ تعمل عبر مجموعة تغييرات.",
        Workspace: "مشتركة مع مساحة عمل واحدة؛ إشعارات ووكلاء وأدلة إجراءات.",
        Personal: "تعمل لصاحبها فقط.",
      },
      createOpen: "إنشاء وفتح",
      created: "أنشئت الأتمتة كمسودة.",
    },
    trigger: {
      kind: "تعمل",
      modes: { event: "عند وقوع حدث", schedule: "وفق جدول زمني", manual: "يدويا", webhook: "Webhook وارد", custom: "مشغل مخصص" },
      event: "الحدث",
      playbook: "لدليل إجراء محدد فقط",
      playbookHint: "اتركه فارغا للاستجابة لكل الأدلة الإجرائية.",
      anyPlaybook: "أي دليل إجراء",
      state: "في مرحلة محددة فقط",
      stateHint: "مفتاح مرحلة مسار العمل، مثل committee-review. اتركه فارغا لكل المراحل.",
      agent: "لوكيل محدد فقط",
      anyAgent: "أي وكيل",
      onlyMine: "الملفات المسندة إلى المالك فقط.",
      manualHint: "لا تعمل إلا عند تشغيلها من هذه الصفحة أو من الواجهة البرمجية أو من خدمة أخرى في المنصة.",
      webhookHint: "تعمل عندما يسلم Webhook وارد حدثا لهذه الأتمتة (انظر التكاملات ← Webhooks).",
      key: "مفتاح المشغل",
      keyHint: "مثل case.stateEntered أو clock.atRisk أو payment.received.",
      config: "إعدادات المشغل (JSON)",
    },
    schedule: {
      presets: { weekdays: "أيام العمل 07:00", daily: "كل يوم 07:00", monday: "أيام الاثنين 07:00", monthly: "أول كل شهر 06:00", quarterly: "ربع سنوي (يوم 5) 06:00", yearly: "سنوي (15 يناير) 06:00" },
      cron: "تعبير cron",
      cronHint: "خمسة حقول: الدقيقة الساعة يوم الشهر الشهر يوم الأسبوع.",
      timeZone: "المنطقة الزمنية",
      gst: "توقيت الإمارات (GST)",
      next: "التشغيلات القادمة",
    },
    actions: {
      type: "الإجراء",
      add: "إضافة إجراء",
      empty: "لا توجد إجراءات بعد — يلزم إضافة إجراء واحد على الأقل قبل الإطلاق.",
      up: "نقل لأعلى",
      down: "نقل لأسفل",
      notAllowed: "لا يمكن لأتمتة {{scope}} اتخاذ هذا الإجراء.",
      needsCase: "يتطلب ملفا: استخدمه مع حدث يخص ملفا.",
    },
    fields: {
      to: "المستلم", toHint: "عند تركه فارغا: المسند إليه الملف، أو من أعد الأتمتة إن لم يتعلق بملف. ويذهب التصعيد إلى المدير.",
      text: "الرسالة", textHint: "اختياري؛ تستخدم رسالة قياسية إذا ترك فارغا.", textPlaceholder: "{{eventLabel}}: {{caseNumber}} — {{title}}",
      placeholders: "إدراج",
      agent: "الوكيل",
      brief: "توجيه الوكيل", briefHint: "ما ينبغي أن يقوم به الوكيل؛ تملأ العناصر النائبة عند التشغيل.",
      playbook: "دليل الإجراء",
      parameters: "معاملات دليل الإجراء", parametersHint: "يمكن أن تستخدم القيم عناصر نائبة مثل {{previousQuarter}} أو {{previousMonth}}.",
      paramName: "الاسم", addParam: "إضافة معامل",
      title: "عنوان الملف", titleHint: "اختياري؛ افتراضيا اسم دليل الإجراء والفترة.",
      priority: "رفع الأولوية إلى",
      trigger: "الانتقال", triggerHint: "اسم انتقال مسار العمل المطلوب تنفيذه.",
      field: "الحقل", value: "القيمة",
      connector: "الموصل", operation: "العملية", input: "المدخلات (JSON)",
      connectorEmpty: "لا يوجد موصل منشور بعد – أنشئ موصلا من التكاملات ← الموصلات.",
      readOnlyOnly: "أتمتة {{scope}} للقراءة فقط: العمليات التي تغير البيانات معطلة.",
      writes: "تغير البيانات",
      connectorInput: "القيم", connectorInputHint: "ترك القيمة فارغة يعني استخدام قيمتها الافتراضية. يمكن أن تستخدم القيم عناصر نائبة مثل {{previousQuarter}}.",
      pickConnectorFirst: "يلزم اختيار موصل وعملية لإدخال قيمها.",
      noParameters: "لا تتطلب هذه العملية أي قيم.",
      defaultValue: "الافتراضي: {{value}}",
      saveTo: "حفظ النتيجة", saveToNone: "الاكتفاء بسجل التشغيل", saveToMatter: "إيداعها في الملف كمصنف (XLSX)",
      saveToNoTable: "لا ترجع هذه العملية جدولا، فلا يوجد ما يودع.",
      recordType: "نوع السجل", template: "قالب الخطاب", service: "الخدمة المطلوب بدؤها",
      fields: "حقول السجل", fieldsHint: "كل حقل من حقول السجل وقيمته؛ يمكن أن تستخدم القيم عناصر نائبة مثل {{caseNumber}}.",
      values: "قيم الخطاب", valuesHint: "قيم إضافية يملؤها القالب حسب الاسم.",
      intake: "إجابات نموذج الطلب", intakeHint: "كل حقل من حقول نموذج طلب الخدمة وقيمته.",
      linkCase: "الربط بالملف", linkCaseHint: "true أو false؛ القيمة الافتراضية true عند وجود ملف.",
      workbookTitle: "عنوان المصنف", workbookTitleHint: "اختياري؛ افتراضيا اسم العملية والفترة. تملأ العناصر النائبة عند التشغيل.",
      subscription: "اشتراك Webhook", subscriptionEmpty: "لا يوجد اشتراك Webhook مفعل – تتم إضافة الاشتراك من الوصول ← Webhooks.",
      workspace: "مساحة العمل", workspaceHint: "اتركه فارغا لاستخدام مساحة عمل الأتمتة نفسها.", days: "الفترة (بالأيام)", daysHint: "المدة التي يغطيها الموجز قبل اليوم وبعده: من 1 إلى 31 يوما، و7 أيام افتراضيا.",
      throttle: "فترة التهدئة (دقائق)", throttleHint: "تخطي التشغيلات المتكررة للملف نفسه خلال هذه الفترة؛ 0 للتشغيل في كل مرة.",
      enabledHint: "هل تبدأ الأتمتة مفعلة بعد إطلاقها. ويمكن إيقافها مؤقتا في أي وقت دون إطلاق جديد.",
      invalidJson: "صيغة JSON غير صحيحة.",
    },
    recipient: { default: "افتراضي", owner: "المالك", assignee: "المسند إليه", members: "أعضاء مساحة العمل", roles: "كل من يحمل الدور", person: "شخص محدد (user:…)" },
    vars: {
      priority: "الأولوية", serviceKey: "دليل الإجراء أو الخدمة", state: "المرحلة", status: "الحالة", workspaceKey: "مساحة العمل", assigneeUserId: "المسند إليه (معرف المستخدم)",
      isMatter: "ملف داخلي", title: "العنوان", daysRemaining: "الأيام المتبقية (المواعيد)", clock: "الموعد النهائي", category: "تصنيف المستند",
      fromApplicant: "رفعه مقدم الطلب", agentKey: "الوكيل (المسودات)", confidence: "ثقة المسودة", urgency: "إلحاح المسودة", triggerSource: "مصدر التشغيل",
    },
    editor: {
      helpTitle: "محرر الأتمتة",
      notFound: "لم يعثر على الأتمتة",
      notFoundBody: "لا توجد أتمتة بالمفتاح \"{{key}}\".",
      nameRequired: "يلزم إدخال اسم للأتمتة.",
      when: "عند", whenHint: "ما يبدأ الأتمتة.",
      onlyIf: "بشرط", onlyIfHint: "شرط اختياري على الحدث والملف المعني.",
      noCondition: "دون شرط — تعمل في كل مرة.",
      then: "ثم", thenHint: "تنفذ الإجراءات بالترتيب؛ ولا يوقف إخفاق إجراء ما يليه.",
      settings: "الإعدادات", settingsHint: "الاسم والنطاق وعدد مرات التشغيل المسموح بها.",
      summary: "بعبارات واضحة", summaryHint: "تتحقق منها المنصة أثناء التحرير.", checking: "جار التحقق…",
      ready: "جاهزة للإطلاق.",
      activity: "النشاط", runs: "التشغيلات", failures: "الإخفاقات", nextRun: "التشغيل القادم", owner: "المالك",
      fromChat: "أنشئت من محادثة في المساعد الذكي.",
      pause: "إيقاف مؤقت", resume: "استئناف", paused: "أوقفت الأتمتة مؤقتا.", resumed: "استؤنفت الأتمتة.",
      openDraft: "فتح المسودة v{{version}}",
      liveNotice: "النسخة {{version}} هي السارية؛ وتحل هذه المسودة محله بعد اعتماد إطلاقها.",
      openLive: "فتح النسخة السارية",
      personalNotice: "مراقب شخصي يخص {{owner}} ويدار من المساعد الذكي. يمكن للمسؤولين إيقافه مؤقتا وتشغيله والاطلاع على سجله هنا.",
      stageTitle: "أتمتة: {{name}}",
      stageBody: "تحفظ المسودة وتضاف إلى مجموعة تغييرات، ويعتمد مسؤول ثان الإطلاق قبل أن تسري.",
      newVersionBody: "ينشئ المسودة v{{version}} نسخة من هذه النسخة، وتستمر النسخة السارية في العمل حتى تطلق الجديدة.",
      codeHint: "الأتمتة بصيغة JSON — كما تحملها مجموعات التغيير والحزم. زر «تطبيق» يحمل التعديلات في المحرر.",
    },
    run: {
      title: "تشغيل",
      intro: "تشغيل النسخة السارية الآن. تحتاج أتمتة الأحداث إلى الملف الذي يخصه الحدث، بخلاف الأتمتة المجدولة واليدوية.",
      case: "الملف",
      caseHint: "رقمه أو معرفه. اختياري؛ مطلوب للإجراءات على ملف (الملاحظات، الإسناد، التصعيد).",
      caseInvalid: "يلزم إدخال رقم ملف مثل GRV-2026-000001، أو معرفه.",
      dryRun: "تشغيل تجريبي",
      dryRunHint: "يسجل ما كان سيفعله كل إجراء دون تغيير أي شيء.",
      test: "تشغيل تجريبي",
      now: "تشغيل الآن",
      recent: "الأخيرة:",
      openLog: "فتح سجل التشغيل",
    },
    runs: {
      empty: "لا توجد تشغيلات بعد",
      emptyHint: "يسجل هنا كل تشغيل — فعلي أو تجريبي — مع ما قام به كل إجراء.",
      trigger: "المشغل", case: "الملف", actions: "الإجراءات", duration: "المدة", when: "الوقت",
      conditionFailed: "لم يتحقق الشرط.",
      noActions: "لم ينفذ أي إجراء.",
    },
  },
  feedback: {
    title: "البلاغات الواردة",
    subtitle: "ما أبلغ عنه المستخدمون من الشاشة التي كانوا عليها، مع صورة الصفحة وعنوانها والإصدار المستخدم.",
    empty: "لم ترد أي بلاغات.",
    all: "الكل",
    reporter: "مقدم البلاغ",
    page: "الصفحة",
    screenshot: "الشاشة",
    note: "ملاحظة للسجل",
    categories: { Wording: "الصياغة", Layout: "التصميم", Error: "خطأ", Suggestion: "اقتراح", Other: "أخرى" },
    statuses: { New: "جديد", InProgress: "قيد المعالجة", Resolved: "تمت المعالجة", Dismissed: "مستبعد" },
    setStatus: "تعيين الحالة: {{status}}",
    updated: "تم تحديث الحالة.",
    allSections: "كل الأقسام",
    unclassified: "لم يصنف بعد",
    classes: { Critical: "جسيم", Major: "رئيسي", Minor: "بسيط" },
    areas: { Threshold: "حد الإخطار", Deadline: "موعد نظامي", Fee: "رسم" },
    sections: {
      EC: "التركز الاقتصادي", AC: "الشكاوى", WB: "البلاغات", EX: "طلبات الاستثناء", EA: "تعديل الاستثناءات", GR: "التظلمات", LE: "الاستفسارات القانونية",
      RQ: "طلبات البيانات والآراء الفنية", DB: "بنك البيانات ودراسات السوق", DW: "مراقبة الصفقات", ST: "الإحصاءات", AD: "السياسات", PW: "المنصة كلها",
    },
    disagreement: "تقترح Net0 تصنيف {{proposed}}، ويسري تصنيف الإدارة ({{applies}}) إلى أن ترد الإدارة.",
    history: {
      Classified: "صنفه {{by}}: {{cls}}",
      Upheld: "أبقى {{by}} على التصنيف: {{cls}}",
      Proposed: "اقترحت Net0 ({{by}}) تصنيف {{cls}}",
    },
    classify: {
      action: "تصنيف العيب",
      change: "تغيير التصنيف",
      title: "تصنيف الإدارة للعيب",
      hint: "جسيم أو رئيسي أو بسيط كما يعرفها التقرير الموضوعي (الشرط 1.7). يسري التصنيف فورا، ومنه ما دامت Net0 تعترض عليه.",
      class: "التصنيف",
      area: "مجال لا يقبل أي خطأ",
      areaHint: "حدود الإخطار والمواعيد النظامية والرسوم لا تقبل أي خطأ (الشرط 1.8): أي عيب فيها يمنع اعتماد القسم.",
      noArea: "لا شيء مما سبق",
      reasons: "الأسباب",
      submit: "تسجيل التصنيف",
      saved: "سجل التصنيف.",
    },
    propose: {
      action: "اقتراح تصنيف آخر",
      title: "اقتراح Net0 لتصنيف آخر",
      hint: "يبقى تصنيف الإدارة ({{current}}) هو الساري إلى أن ترد الإدارة على الاقتراح.",
      submit: "تسجيل الاقتراح",
      saved: "سجل الاقتراح بجانب تصنيف الإدارة.",
    },
    acceptance: {
      title: "حد القبول حسب القسم",
      hint: "الشرط 1.8: لا عيب جسيما ولا رئيسيا، ولا يزيد عدد العيوب البسيطة على {{max}}، وتصحح كلها قبل الاعتماد، ولا خطأ في حد أو موعد أو رسم. يحتسب من العيوب المبلغ عنها هنا، أما القبول نفسه فتقيسه الإدارة على ملفاتها المرجعية.",
      section: "القسم",
      noErrorArea: "حد أو موعد أو رسم",
      unclassified: "بانتظار التصنيف",
      verdict: "الوضع",
      verdicts: { Met: "استوفى الحد", NotMet: "لم يستوف الحد", Pending: "بانتظار التصنيف" },
      legend: "كل تصنيف يقرأ: العيوب القائمة / كل العيوب المبلغ عنها.",
    },
  },
} as const;
